export default {
    setting: {
        language: "Supaprastinta kinų",
        dialogDetermine: "Žinoma",
        dreivatives: "Pristatymo",
        markets: "Citatos",
        assets: "turto",
        liquidity: "Likvidumo kasyba",
        helpCentre: "Pagalbos centras",
        announcementCenter: "Skelbimų centras",
        about: "apie",
        bulletinCentre: "Skelbimų centras",
        serviceAgreement: "Paslaugų sutartis",
        support: "parama",
        onlineSupportCustomerService: "internetinė paslauga",
        suggestionsAndFeedback: "Pasiūlymai ir atsiliepimai",
        service: "Tarnauti",
        download: "parsisiųsti",
        coinApplication: "Monetų sąrašo programa",
        privacyStatement: "Privatumo pareiškimas",
        trade: "sutartinė prekyba",
        standardConteact: "Tvarus",
        signOut: "Atsijungti",
        assetWallets: "Turto piniginė",
        financeRecords: "Paskyros keitimo įrašai",
        identification: "Autentifikavimas",
        personalCenter: "Asmeninis centras",
        chooseLanguage: "Pasirinkite kalbą",
        tips: "užuomina",
        dark: "tamsus režimas",
        light: "dienos režimas",
        hosting: "Hostingas",
        languageTitle: "kalba",
        convertCurrency: "Konvertuoti valiutą",
        cancel: "Atšaukti",
        aboutUs: "apie mus",
        standard: "Standarto tęstinumas",
        share: "Dalintis",
        introduce: "Platformos įvadas",
        set: "nustatyti",
        changePassword: "Keisti prisijungimo slaptažodį",
        denomination: "Citatos valiuta",
        color: "Spalvų konfigūracija",
        code: "versijos numeris",
        color1: "Raudona kyla, o žalia krinta",
        color2: "Žalia pakyla, o raudona krinta",
        setLangue: "kalbos nustatymas",
        vip: "VIP privalumai",
        vip2: "Dabartinis VIP lygis",
        safeMenu: "Apsaugos centras",
        conventional: "sutartinis",
        other: "kitas",
        quickTips: "Pridėkite iki 3 sparčiųjų funkcijų mygtukų",
        quickTransaction: "Greitas sandoris",
        safeConvenient: "Saugu ir patogu",
        timeSharing: "laiko pasidalijimas",
        currentLevel: "Dabartinis lygis",
        levelBenefits: "%{level}pajamų lygio",
        teamLevel: "Komandos lygis",
        levelLower: "%{level}pavaldinys",
        rules: "Taisyklės aprašymas",
        bindWithdrawalAddress: "Įrišimo išėmimo adresas",
        tipsBindWithdrawalAddress: "Jūs dar nesusiejote savo atsiėmimo adreso, pirmiausia susiekite jį",
        walletAddressFormatIncorrect: "Piniginės adreso formatas netinkamas",
        tradeRules1: "Numatykite kilimą ir nuosmukį ateityje. Kaina užsakymo metu naudojama kaip pradinė kaina, o kaina paskutinę prognozavimo laikotarpio sekundę – atsiskaitymo kaina kaina yra mažesnė už pradinę kainą, tai reiškia mažėjimą.",
        tradeRules2: "1.Kas yra sutartis?",
        tradeRules3: "Ši platforma teikia USDT pagrindu sudarytas neterminuotas sutartis. Neterminuotos sutartys neturi pristatymo datos ir vartotojai jas gali turėti amžinai.",
        tradeRules4: "2.Kas yra marža",
        tradeRules5: "Virtualioje sutarčių rinkoje vartotojams tereikia sumokėti nedidelę pinigų sumą tam tikra proporcija pagal sutarties kainą kaip finansinę sutarties įvykdymo garantiją, o tada jie gali dalyvauti perkant-parduodant sutartį. Tokios lėšos yra virtualus sutarties indėlis. \nSutartyse šioje platformoje taikomas atskirų sąskaitų maržos modelis. Kiekviena valiuta atitinka sutarties sąskaitą. Skirtingų sutarties valiutų sąskaitos turtas ir pozicijos yra nepriklausomi vienas nuo kito, o pervedimai ir operacijos tarp skirtingų sutarties sąskaitų neturi įtakos. Atidarius vartotojo sutarties sąskaitą, visų sutarties sąskaitoje esančių pozicijų rizika ir nauda bus skaičiuojami kartu.",
        tradeRules6: "3.Kaip apskaičiuoti maržą",
        tradeRules7: "Pozicijos marža = sutarties nominali vertė * nebaigtų sutarčių skaičius / sverto daugiklis\nužšaldyta marža = visų sėkmingai pateiktų pavedimų ir atidaromų pavedimų maržos suma dabartiniame pavedime\neprieinama marža = sąskaitos likutis - pozicijos marža - įšaldyta marža",
        tradeRules8: "4.Kaip apskaičiuoti maržos normą",
        tradeRules9: "Maržos norma yra vartotojo turto rizikos matas. \nMaržos norma = (nerealizuotas pelnas ir nuostolis + pozicijos marža + turima marža + įšaldymo marža - likvidavimo mokestis) / pozicijos marža \nKuo mažesnė maržos norma, tuo didesnė sąskaitos rizika. Kai maržos norma yra mažesnė arba lygi 0%, bus pradėtas priverstinis likvidavimas.",
        tradeRules10: "5. Kokia numatoma priverstinio likvidavimo kaina?",
        tradeRules11: "Numatoma priverstinio likvidavimo kaina, ty kaina, apskaičiuota sistemos, kuri teoriškai sukelia priverstinį likvidavimą, yra tik orientacinė ir gali šiek tiek nukrypti nuo tikrosios vertės.",
        tradeRules12: "6. Koks yra bendras sąskaitos nuosavas kapitalas ir nerealizuotas pelnas ir nuostolis?",
        tradeRules13: "Visas sąskaitos nuosavas kapitalas = sąskaitos likutis + nerealizuotas pelnas ir nuostolis\nNerealizuotas pelnas ir nuostolis yra šiuo metu vartotojo turimos pozicijos pagal valiutos sutartį pelnas ir nuostolis Nerealizuotas pelnas ir nuostolis pasikeis su paskutiniais sandorio kainos pasikeitimais. \nNerealizuotas ilgųjų pozicijų pelnas ir nuostolis = (1/vidutinė pozicijos kaina – 1/paskutinio sandorio kaina) * ilgųjų pozicijų sutarčių skaičius * sutarties nominali vertė * paskutinė sandorio kaina \n trumpųjų pozicijų nerealizuotas pelnas ir nuostolis = (1/ paskutinė sandorio kaina - 1/ Vidutinė pozicijos kaina) * Trumpųjų sutarčių skaičius * Sutarties nominali vertė * Paskutinė sandorio kaina",
        text1: "sąskaitos saugumas",
        text2: "dienos ir nakties režimas",
        text3: "Išvalyti talpyklą",
        text4: "Ar tikrai norite atsijungti?",
        text5: "Ar tikrai norite išvalyti talpyklą?",
        text6: "daugiakalbis",
        text7: "Kad apsaugotumėte savo saugumą, rekomenduojame įjungti bent vieną dviejų veiksnių autentifikavimą"
    },
    login: {
        email: "",
        emailLogin: "Prisijungimas el",
        phoneLogin: "Prisijunkite telefonu",
        login: "Prisijungti",
        register: "Registruotis",
        title1: "Prekiaukite bet kada ir bet kur ir peržiūrėkite rinkos sąlygas realiuoju laiku",
        title2: "Prekiaukite bet kada ir bet kur ir peržiūrėkite rinkos sąlygas realiuoju laiku",
        title3: "Patikimiausia kriptovaliutų prekybos platforma",
        formTitle1: "Prisijungimas prie paskyros",
        formTitle2: "Sveikas sugrįžęs! Prisijunkite naudodami savo el. pašto adresą, telefono numerį",
        btn1: "Mobilusis telefonas",
        btn2: "Paštas",
        btn3: "Prisijungti",
        btn4: "Registruotis",
        btn5: "pamiršti slaptažodį?",
        field1: "Telefono numeris",
        field2: "Slaptažodis",
        field3: "Paštas",
        placeholder1: "tauta",
        placeholder2: "Įveskite telefono numerį",
        placeholder3: "Įveskite slaptažodį",
        placeholder4: "prašome įvesti savo el",
        content12: "Įveskite telefono numerį",
        content13: "Įveskite slaptažodį",
        content14: "prašome įvesti savo el",
        content16: "Skaitmeninio turto finansinės paslaugos",
        loginSuccess: "sėkmingas prisijungimas ",
        chooseArea: "Pasirinkite srities kodą",
        placeholder5: "Pasirinkite šalies kodą",
        placeholder6: "prisimink mano slaptažodį",
        placeholder7: "Atsisiųskite APP",
        placeholder8: "Susisiekite su klientų aptarnavimo tarnyba",
        placeholder9: "Pasirinkite šalį arba regioną",
        placeholder10: "vietovės kodas",
        placeholder11: "Prisijungimas prie piniginės",
        placeholder12: "Operacija nepavyko, pereikite prie",
        placeholder13: "piniginė"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "apie",
        aboutCoinbeadCenterDetails: "Ji turi pirmaujančią pasaulyje blockchain turto prekybos platformą ir valdo visą ekosistemą.",
        footDetails1: "dienos prekybos apimtis",
        footDetails2: "operacijų per sekundę",
        footDetails3: "Pagalbos centras",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "Tai visame pasaulyje žinoma tarptautinė skaitmeninio turto svetainė, daugiausia teikianti monetas ir skaitmeninio turto išvestinius produktus, tokius kaip Bitcoin (BTC), Litecoin (LTC) ir Ethereum (ETH) pasaulio vartotojams.",
        coinbeadCenterDetailsm: "Taikydami pažangias technologijas, tokias kaip GSLB, tinklo serverius, tinklo operacijas, tinklus, kelių mašinų didelės spartos atminties prekybos variklius, šaltąsias pinigines, išmaniąsias neprisijungus veikiančias karštąsias pinigines ir kt., savo klientus aptarnaujame naudodami kelis terminalus, tokius kaip žiniatinklio mobilieji telefonai ir asmeniniai kompiuteriai. Teikti saugias, stabilias ir patikimas skaitmeninių tarifų operacijų paslaugas. Tuo pačiu metu tobuliname ir atnaujiname produktus ir paslaugas atsižvelgdami į vartotojų pasiūlymus ir poreikius, kad kiekvienam klientui būtų teikiamos geresnės paslaugos, o novatoriškos vartotojo patirties gerinimui nėra galo.",
        infrastructureCenterTitle: "infrastruktūrą",
        infrastructureCenterDetails: "Mūsų misija – teikti infrastruktūros paslaugas visai blockchain ekosistemai",
        freeCenterTitle: "Laisvas",
        freeCenterDetails: "Mūsų vizija – priversti pinigus laisvai tekėti visame pasaulyje. Tikime, kad šios laisvės sklaida gali padaryti pasaulį geresne vieta",
        futureCenterTitle: "Technologijų ateities pionieriai",
        futureCenterDetails: "Atverkite technologijų ateitį",
    },
    applicationForListing: {
        title: "Monetų sąrašo programa",
        projectName: "projekto pavadinimas",
        tokenName: "Žetono vardas",
        projectDescription: "Projekto aprašymas",
        contractAddress: "Sutarties adresas",
        officialWebsite: "Oficiali svetainė",
        ContactAndEmail: "Kontaktinis Elektroninis paštas",
        ContactAndName: "Kontaktinis vardas",
        file: "Įkelti priedą",
        pleaseEnter: "prašome įvesti",
        enterFile: "Prašome įkelti failus",
        upload1: "Šiuo metu galima pasirinkti tik 1 failą，",
        upload2: "Šį kartą pasirinkau",
        upload3: "failus，",
        upload4: "Iš viso pasirinkta",
        upload5: "failus",
    },
    public: {
        submit: "Pateikti",
        copySuccessfully: "Nukopijuota sėkmingai",
        copyFailed: "Kopijuoti nepavyko",
        noDate: "Nėra duomenų",
        submitSuccessfully: "Sėkmingai pateikta",
        goBack: "grįžti į paskutinį puslapį",
        cancel: "Atšaukti",
        home: "Namai",
        loading: "įkeliama...",
        confirm: "patvirtinti",
        loadingFailed: "tinklo anomalija",
        nomore: "ne daugiau",
        tryAgain: "Atnaujinkite puslapį / išeikite iš programos ir įkelkite dar kartą!",
        hot: "Populiarios vietovės",
    },
    inviteFriends: {
        inviteFriends: "Pasidalink su draugais",
        freedomOfWealth: "Tegul turtai būna laisvi kartu",
        myInvitationCode: "mano pakvietimo kodas",
        clickCopy: "Spustelėkite norėdami nukopijuoti",
        myInvitationLink: "Mano kvietimo nuoroda",
        clicktoSaveTheQRCode: "Spustelėkite, kad išsaugotumėte QR kodą",
        saveQRCode: "Pakvieskite QR kodą",
        numberOfSubordinates: "Pavaldinių skaičius",
        rebateIncome: "Nuolaidos pajamos",
        people: "žmonių",
        myPromotionRevenue: "Mano reklamos pajamos",
        numberOfDirectSubordinates: "Tiesioginių pavaldinių skaičius",
        totalNumberOfSubordinates: "Bendras pavaldinių skaičius",
        directSubordinateReturnsCommission: "Komisinių nuolaida tiesioginiams pavaldiniams",
        theTotalCommission: "visa nuolaida",
        checkHistory: "Peržiūrėkite nuolaidų įrašus",
        history: "Komisijos rekordas",
        theLowerAccount: "Pavaldžioji sąskaita",
        type: "tipo：",
        serviceCharge: "tvarkymo mokestis：",
        percentageofCommissionReturned: "Nuolaidų santykis：",
        commissionrebateAmount: "Nuolaidos suma：",
        time: "laikas：",
        typeName1: "Įkrovimas ir komisiniai",
        typeName2: "MT užsakymų tvarkymo mokestis trijų lygių paskirstymas",
        typeName3: "MT pelningas trijų lygių paskirstymas",
        typeName4: "Siuntimo apdovanojimai",
        typeName30: "Įkrovimas ir komisiniai",
        typeName31: "Periodinis prekybos pelno grąžinimas",
        typeName32: "Likvidumo kasybos pelno grąžinimas",
        typeName45: "Sandorio mokesčio grąžinimas",
        typeName46: "Komisinių nuolaida už nuosavo tvarkymo mokestį",
        typeName50: "Pristatymo sutarties tvarkymo mokesčio nuolaida",
        typeName51: "Nuolatinė sutarties tvarkymo mokesčio nuolaida",
        typeName52: "Papildoma komisinių nuolaida už pristatymo sutarties tvarkymo mokesčius",
        typeName53: "Papildoma komisinių nuolaida už neterminuotus sutarties tvarkymo mokesčius",
        typeName54: "Papildomos nuolaidos nuolatiniams sutarties tvarkymo mokesčiams",
        shareRules1: "Kvietimo instrukcijos",
        shareRules2: "Įeikite į kvietimų centrą, nukopijuokite kvietimo nuorodą arba kodą ir pasidalykite juo su draugais. Draugai gali tapti jūsų pavaldiniais užsiregistravę su jūsų pakvietimo kodu.",
        shareRules3: "Uždirbkite nuolaidas",
        shareRules4: "Kai pavaldiniai atlieka sandorius, galite gauti atitinkamus komisinius, palaikomi iki trijų lygių pavaldiniai. Pavyzdžiui, jei pakviečiate draugą A, A kviečia B, o B pakviečia C, tada A, B ir C platformoje gali sudaryti sutartis ir atlikti kitus sandorius, o jūs visi galite gauti atitinkamus komisinius.",
        shareRules5: "Komandos lygis",
        shareRules6: "Kuo daugiau paaukštinsite pirmojo lygio pavaldinių, tuo aukštesnis komandos lygis ir tuo didesnės nuolaidos galėsite mėgautis. Komandos lygiai yra suskirstyti į LV1-LV6. Atnaujinimo taisyklės parodytos toliau esančioje lentelėje, kur „N“ yra pirmojo lygio pavaldinių, kurie įkrovė ir atliko autentifikavimą tikruoju vardu, skaičius.",
        shareRules7: "Kai pavaldiniai stato statymus dėl pristatymo sutarčių, galite gauti komisinius, proporcingus jų statymams.",
        upgradeConditions: "Reikalauti",
        recommendedNumberOfPeople: "Rekomenduojamas žmonių skaičius"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "Pasiūlymai ir atsiliepimai",
        text: "Jei naudojimo metu susiduriate su klaidų arba turite produktų pasiūlymų, pateikite atsiliepimą.",
        email: "elektroninio pašto adresas",
        enterEmail: "Įveskite el. pašto adresą",
        enterCorrectEmail: "Įveskite teisingą el. pašto adresą",
        title: "titulą",
        enterTitle: "Įveskite klausimo pavadinimą",
        describeTheProblem: "Apibūdinkite problemą",
        enterDescribeTheProblem: "Įveskite aprašytą problemą",
        submit: "Pateikti",
    },
    help: {
        enterSearch: "Paieška",
        title: "Pagalbos centras",
        search: "Įveskite savo klausimą",
        text1: "Supraskite savo poreikius ir toliau teikite jums patogesnes paslaugas"
    },
    announcement: {
        enterSearch: "Paieška",
        title: "Skelbimų centras",
        search: "Įveskite savo klausimą"
    },
    privacy: {
        title: "Privatumo pareiškimas",
        content1: "1. Kokia asmeninė informacija apie vartotojus renkama?",
        content2: "Asmeninė informacija renkama siekiant teikti produktus ir paslaugas bei nuolat juos tobulinti。",
        content3: "Toliau pateikiami mūsų renkamos asmeninės informacijos tipai：",
        content4: "Informacija, kurią mums pateikiate: Mes gauname ir saugome bet kokią informaciją, kurią pateikiate, susijusią su Platforma. Galite pasirinkti nepateikti tam tikros informacijos, tačiau dėl to negalėsite naudotis tam tikromis „šios platformos paslaugomis“. Informacijos, kurią mums pateikiate, pavyzdžiai yra：",
        content5: "vardas",
        content6: "adresu",
        content7: "Pilietybės šalis",
        content8: "ID nuotrauka",
        content9: "Mobiliojo telefono numeris/el",
        content10: "Kita informacija, kuri padeda mums jus identifikuoti",
        content11: "Automatiškai renkama informacija: automatiškai renkame ir saugome tam tikro tipo informaciją apie jūsų naudojimąsi Platformos paslaugomis, kaip ir daugelis svetainių, naudojame slapukus ir kitus unikalius identifikatorius. Mes gauname tam tikros rūšies informaciją, kai jūsų interneto naršyklė arba įrenginys pasiekia platformą. Informacijos, kurią renkame ir analizuojame, pavyzdžiai:：",
        content12: "Interneto protokolo (IP) adresas, jungiantis asmeninį kompiuterį prie interneto；",
        content13: "Asmeninio įrenginio ar kompiuterio prisijungimo informacija, el. pašto adresas, slaptažodis ir vieta；",
        content14: "Versijos ir laiko juostos nustatymai；",
        content15: "operacijų istorija。",
        content16: "Informacija iš kitų šaltinių: galime rinkti informaciją apie jus iš kitų šaltinių, pavyzdžiui, iš kredito biurų kredito istorijos. Šią informaciją naudosime sukčiavimo prevencijai ir aptikimui.",
        content17: "2. Ar vaikai gali juo naudotis?",
        content18: "Ši platforma neleidžia asmenims iki 18 metų naudotis „Paslaugomis“”。",
        content19: "3. Kam naudojami slapukai ir kiti identifikatoriai?",
        content20: "Naudojame slapukus ir panašius įrankius, siekdami optimizuoti vartotojų patirtį, teikti paslaugas ir suprasti, kaip klientai naudojasi mūsų paslaugomis, kad galėtume atlikti tikslinius patobulinimus. Naudojame slapukus siekdami užtikrinti, kad mūsų sistema atpažintų jūsų naršyklę ar įrenginį ir teiktų jums paslaugas.",
        content21: "Mes naudojame operacinius slapukus ir panašius įrankius (bendrai „Slapukai“), kad galėtume teikti paslaugas, pvz：",
        content22: "Prisijungę ir naudodami mūsų paslaugas atpažinsite jus。",
        content23: "Teikti pritaikytas funkcijas ir paslaugas。",
        content24: "Apsaugokite nuo nesąžiningos veiklos。",
        content25: "Pagerinti saugumą。",
        content26: "Stebėkite savo nuostatas (pvz., valiutą ir kalbą).",
        content27: "Taip pat naudojame slapukus, kad suprastume, kaip vartotojai naudojasi mūsų paslaugomis, kad galėtume atlikti tikslinius patobulinimus.",
        content28: "4. Ar bus dalijamasi mano asmenine informacija?",
        content29: "Vartotojų informacija yra svarbi mūsų verslo dalis, todėl mes neparduosime naudotojų asmeninės informacijos kitiems. Ši platforma dalinsis naudotojų asmenine informacija su savo dukterinėmis įmonėmis arba filialais toliau nurodytomis aplinkybėmis. Šios dukterinės įmonės ar filialai privalo laikytis šio privatumo pareiškimo arba bent jau laikytis tokios pat apsaugos kaip ir šiame privatumo pareiškime aprašytos apsaugos priemonės.",
        content30: "Trečiųjų šalių paslaugų teikėjai: įdarbiname kitas įmones ir asmenis, kad jie atliktų funkcijas mūsų vardu. Tokių funkcijų pavyzdžiai: duomenų analizė, rinkodaros pagalbos teikimas, mokėjimų apdorojimas, turinio perdavimas, kredito rizikos vertinimas ir valdymas. Šie trečiųjų šalių paslaugų teikėjai turi prieigą prie asmeninės informacijos, reikalingos jų funkcijoms atlikti, tačiau negali jos naudoti jokiems kitiems tikslams. Be to, jie turi tvarkyti asmeninę informaciją laikydamiesi šio privatumo pareiškimo ir taikomų duomenų apsaugos įstatymų.",
        content31: "Verslo perkėlimas: mūsų verslui ir toliau augant, galime parduoti arba pirkti kitas įmones ar paslaugas. Atliekant tokias operacijas, naudotojo informacija paprastai yra tarp perduoto verslo turto, tačiau jai galioja pažadai, esantys bet kuriame ankstesniame privatumo pareiškime (nebent, žinoma, vartotojas sutinka kitaip). Be to, jei būtų įsigyta mūsų įmonė ar iš esmės visas jos turtas, informacija apie vartotoją taip pat būtų perduodama. Mūsų įmonės ir kitų apsauga: kai manome, kad paskyros ir kitos asmeninės informacijos atskleidimas yra tinkamas, kad būtų laikomasi įstatymų arba mūsų reguliavimo įsipareigojimų, vykdyti arba taikyti mūsų naudojimo sąlygas ir kitas sutartis arba mūsų teises, nuosavybę ar saugumą. vartotojų ar kitų asmenų Kada mes paskelbsime paskyrą ir kitą asmeninę informaciją. Tai apima keitimąsi informacija su kitomis įmonėmis ir organizacijomis, siekiant apsisaugoti nuo sukčiavimo ir sumažinti kredito riziką.",
        content32: "5. Tarptautinis asmens duomenų perdavimas",
        content33: "Jūsų duomenis galime perkelti už Europos ekonominės erdvės (toliau – EEE) ribų. Įdiegsime tinkamas apsaugos priemones, siekdami užtikrinti, kad toks perdavimas atitiktų taikomas duomenų apsaugos taisykles, nebent Europos Komisija patvirtintų, kad šalis, kuriai perduodami duomenys, užtikrina tinkamą apsaugos lygį.",
        content34: "6. Ar mano asmeninė informacija yra saugi?",
        content35: "Sistemas sukūrėme atsižvelgdami į jūsų saugumą ir privatumą. Siekdami apsaugoti asmeninės informacijos saugumą perdavimo metu, naudojame šifravimo protokolus ir programinę įrangą.",
        content36: "Rinkdami, saugodami ir atskleisdami asmeninę informaciją, visada taikome fizines, elektronines ir procedūrines apsaugos priemones. Mūsų saugumo procedūros reiškia, kad mums gali tekti patikrinti jūsų tapatybę prieš atskleidžiant jums asmeninę informaciją.",
        content37: "Svarbiausias dalykas, kurį galite padaryti, yra apsaugoti savo asmeninės paskyros slaptažodžius nuo neteisėtos prieigos. Rekomenduojame nustatyti unikalų paskyros slaptažodį, kuris skiriasi nuo kitų internetinių paskyrų. Ir būtinai atsijunkite naudodami bendrą kompiuterį.",
        content38: "7. Kaip turėčiau apsaugoti savo asmeninę informaciją?",
        content39: "Jei turite klausimų ar prieštaravimų dėl to, kaip renkame ir apdorojame asmeninę informaciją, susisiekite su klientų aptarnavimo darbuotojais",
        content40: "Sutikę, kad jūsų asmeninę informaciją tvarkytume konkrečiu tikslu, galite bet kada atšaukti savo ketinimą ir mes nustosime tvarkyti jūsų duomenis šiuo tikslu.",
        content41: "Be to, jūs turite teisę prašyti prieigos prie asmens duomenų, juos ištaisyti ir ištrinti bei prašyti duomenų perkeliamumo pagal galiojančius įstatymus. Taip pat galite nesutikti, kad mes tvarkytume jūsų asmens duomenis, arba prašyti, kad tam tikromis aplinkybėmis būtų apribotas jūsų asmens duomenų tvarkymas.",
        content42: "8. ES GDPR ir JK duomenų apsaugos įstatymas – teisinis pagrindas",
        content43: "ES GDPR ir JK duomenų apsaugos įstatymai reikalauja, kad naudotume asmeninę informaciją laikytis teisinio pagrindo. Mūsų pagrindas priklauso nuo konkrečių tikslų, kuriems naudojama asmeninė informacija. Šios bazės apima：",
        content44: "Sutarties vykdymas – teikti arba bendrauti su jumis apie produktus ar paslaugas, įskaitant jūsų asmeninės informacijos naudojimą priimant ir apdoroti užsakymus bei apdoroti mokėjimus.",
        content45: "Mūsų teisėti verslo interesai ir naudotojų interesai – aptinkame ir užkertame kelią sukčiavimui bei piktnaudžiavimui, kad apsaugotume savo naudotojų, savęs ar kitų saugumą.",
        content46: "Jūsų sutikimas – mums reikia jūsų sutikimo, kad galėtume tvarkyti jūsų asmeninę informaciją konkrečiais jums nurodytais tikslais. Suteikę mums sutikimą tvarkyti jūsų asmeninę informaciją konkrečiu tikslu, galite bet kada atšaukti savo sutikimą ir mes nustosime tvarkyti jūsų duomenis šiuo tikslu.",
        content47: "Laikykitės teisinių įsipareigojimų – mes naudojame jūsų asmeninę informaciją, kaip to reikalauja teisės aktai. Pavyzdžiui, tapatybės patvirtinimo tikslais renkame banko sąskaitos informaciją.",
        content48: "Pirmiau nurodyti ir kiti teisiniai pagrindai priklauso nuo konkrečių tikslų, kuriems mes naudojame asmeninę informaciją.",
        content49: "9. Naudojimo sąlygos, įspėjimai ir pakeitimai",
        content50: "Jūsų naudojimuisi ir bet kokiam ginčui dėl privatumo taikomas šis pareiškimas ir mūsų naudojimo sąlygos. Jei turite klausimų dėl šios platformos privatumo, susisiekite su mumis ir pateikite išsamų paaiškinimą ir mes mielai išspręsime jūsų problemą. Taip pat turite teisę kreiptis į savo vietos duomenų apsaugos instituciją.",
        content51: "Mūsų verslas nuolat keičiasi, taip pat keičiasi ir mūsų privatumo pareiškimas. Turėtumėte dažnai apsilankyti mūsų svetainėje, kad pamatytumėte naujausius pakeitimus. Jei nesutinkate su peržiūrėtu turiniu, turėtumėte nedelsdami nutraukti prieigą. Išleidus atnaujintą Privatumo politikos versiją, jūsų nuolatinė prieiga reiškia, kad sutinkate su atnaujintu turiniu ir sutinkate laikytis atnaujintos privatumo politikos. Jei nenurodyta kitaip, dabartinis privatumo pareiškimas taikomas visai informacijai, kurią turime apie jus ir jūsų paskyrą.",
    },
    serviceAgreement: {
        title: "Paslaugų sutartis",
        content1: "Ši svetainė yra platforma, skirta vartotojams atlikti skaitmeninio turto sandorius ir teikti susijusias paslaugas (toliau vadinama „paslauga“ arba „paslauga“). Kad būtų patogiau apibūdinti šią sutartį, šioje svetainėje šioje sutartyje kartu vartojami „mes“ arba kiti pirmojo asmens įvardžiai. Kol fizinis asmuo ar kitas subjektas, kuris prisijungia prie svetainės, yra šios svetainės vartotojas, kad būtų patogiau išreikšti šią sutartį, toliau bus naudojamas „jūs“ arba kitas antrasis asmuo. Kad būtų patogiau pristatyti šią Sutartį, mes ir jūs šioje Sutartyje kartu vadinami „Šalimis“, o mes arba jūs atskirai – „Šaliai“.”。",
        content2: "svarbi užuomina：",
        content3: "Čia norime jums priminti：",
        content4: "1 Pats skaitmeninis turtas nėra išduotas jokios finansų įstaigos ar įmonės ar šios svetainės",
        content5: "2 Skaitmeninio turto rinkos yra naujos, nepatvirtintos ir gali neaugti；",
        content6: "3 Skaitmeninį turtą daugiausia naudoja spekuliantai, palyginti mažai naudojamas mažmeninės prekybos ir komercinėse rinkose ir pasaulinės vyriausybės politikos svyravimai；",
        content7: "4  Bendrovė pasilieka teisę bet kuriuo metu sustabdyti arba nutraukti jūsų paskyrą, jei Bendrovė savo nuožiūra nustato, kad jūs pažeidėte šią Sutartį arba kad šios svetainės teikiamos paslaugos ar jūsų naudojimasis šios svetainės teikiamomis paslaugomis yra neteisėtai pagal jūsų jurisdikcijos įstatymus arba sustabdyti arba nutraukti naudojimąsi šios svetainės teikiamomis paslaugomis ar skaitmeninio turto sandoriais. Visiems iš [žemyninės Kinijos, Taivano, Izraelio, Irako, Bangladešo, Bolivijos, Ekvadoro, Kirgizijos, Sevastopolio ir Jungtinės Karalystės (mažmeniniams vartotojams)] draudžiama naudotis šioje svetainėje teikiamomis sutarčių sudarymo paslaugomis. Pirmiau minėtas šalių ar regionų sąrašas pasikeis, atsižvelgiant į skirtingų šalių ar regionų politiką ir produktų tipus. Tuo metu galime jums konkrečiai nepranešti, todėl laiku atkreipkite dėmesį į šios sutarties atnaujinimus.",
        content8: "Prekyba skaitmeniniu turtu kelia itin didelę riziką ir daugeliui žmonių netinka. Jūs suprantate ir suprantate, kad dėl šio sandorio gali būti patirti daliniai arba visiški nuostoliai, todėl sandorio sumą turėtumėte nustatyti atsižvelgdami į tai, kiek nuostolių galite sau leisti. Žinote ir suprantate, kad skaitmeninis turtas generuos išvestinę riziką, todėl kilus klausimams, pirmiausia rekomenduojama kreiptis į profesionalius patarėjus. Be to, be aukščiau paminėtų pavojų, bus ir rizikos, kurių negalima numatyti. Prieš priimdami bet kokį sprendimą pirkti ar parduoti skaitmeninį turtą, turėtumėte atidžiai apsvarstyti ir aiškiai įvertinti savo finansinę padėtį ir aukščiau paminėtą riziką, ir prisiimti už tai patirtus nuostolius.",
        content9: "Įspėjimas tau：",
        content10: "1 Jūs suprantate, kad ši svetainė naudojama tik kaip vieta, kur galite gauti informaciją apie skaitmeninį turtą, rasti sandorio šalis, derėtis ir atlikti sandorius dėl skaitmeninio turto nustatyti atitinkamą skaitmeninį turtą ir (arba) informacijos autentiškumą, teisėtumą ir pagrįstumą, ir pati prisiima su tuo susijusią atsakomybę bei nuostolius.",
        content11: "2 Bet kokios nuomonės, naujienos, diskusijos, analizės, kainos, rekomendacijos ir kita informacija šioje svetainėje yra bendri rinkos komentarai ir nėra investicijų patarimai. Mes nesame atsakingi už jokius nuostolius, tiesiogiai ar netiesiogiai atsiradusius dėl pasitikėjimo šia informacija, įskaitant, bet tuo neapsiribojant, bet kokį pelno praradimą.",
        content12: "3 Ši svetainė pasilieka teisę bet kuriuo metu priimti sprendimą, keisti ar keisti turinį Mes ėmėmės pagrįstų priemonių, kad užtikrintume svetainėje pateiktos informacijos tikslumą, tačiau negalime garantuoti jos tikslumo ir neatsakome už. bet kokius nuostolius ar žalą, atsiradusius dėl šioje svetainėje esančios informacijos arba informacijos trūkumo, atsiradusių dėl vėlavimo ar nesėkmių prisijungiant prie interneto, perduodant ar gaunant bet kokius pranešimus ir informaciją.",
        content13: "4 Taip pat kyla rizika naudojant internetines prekybos sistemas, įskaitant programinės įrangos, aparatinės įrangos ir interneto ryšio gedimus, bet tuo neapsiribojant. Kadangi mes nekontroliuojame interneto patikimumo ir prieinamumo, neprisiimame atsakomybės už iškraipymus, vėlavimus ir ryšio sutrikimus.",
        content14: "5 Draudžiama naudoti šią svetainę siekiant užsiimti bet kokia neteisėta prekyba ar neteisėta veikla, tokia kaip pinigų plovimas, kontrabanda, komercinis kyšininkavimas ir pan. Jei bus aptikti įtariami neteisėti sandoriai ar neteisėta veikla, ši svetainė imsis įvairių priemonių, įskaitant bet neapsiribojant sąskaitų įšaldymu, pranešimu atitinkamoms institucijoms ir pan., mes neprisiimame visų iš to kylančių įsipareigojimų ir pasiliekame teisę reikalauti atsakomybės iš atitinkamų asmenų.",
        content15: "6 Draudžiama naudoti šią svetainę siekiant piktybiškai manipuliuoti rinka, atlikti netinkamus sandorius ir atlikti kitą neetišką prekybos veiklą. prekybos sistema Mes neprisiimame visos atsakomybės, kylančios dėl prevencinių apsaugos priemonių, tokių kaip sąskaitos sustabdymas, ir pasiliekame teisę reikalauti atsakomybės iš atitinkamų asmenų.",
        content16: "1. Bendrieji principai",
        content17: "1.1 „Naudotojo sutartis“ (toliau – „ši sutartis“ arba „šios sąlygos“), susideda iš pagrindinio teksto „Privatumo sąlygos“, „Pažink savo klientą ir kovos su pinigų plovimu politika“ ir įvairių kitų politikos krypčių, kurios buvo paskelbti arba ateityje gali būti paskelbti šioje svetainėje.",
        content18: "1.2 Prieš pradėdami naudotis šios svetainės teikiamomis paslaugomis, turėtumėte atidžiai perskaityti šią sutartį. Jei bet kuriuo metu nesutinkate su šia Sutartimi ir (arba) jos pakeitimu, nedelsdami nustokite naudotis šios svetainės teikiamomis paslaugomis arba nebeprisijunkite prie šios svetainės. Kai prisijungiate prie šios svetainės, naudojatės bet kuriomis šios svetainės paslaugomis ar bet kokiu kitu panašiu elgesiu, tai reiškia, kad supratote ir visiškai sutikote su šios sutarties turiniu, įskaitant bet kokius šios svetainės bet kuriuo metu padarytus šios sutarties pakeitimus.",
        content19: "1.3 Šios svetainės nariu (toliau – nariu) galite tapti užpildę atitinkamą informaciją pagal šios svetainės reikalavimus ir sėkmingai užsiregistravę po kitų atitinkamų procedūrų, registracijos metu paspaudę mygtuką „Sutinku“. procese pasirašote susitarimo su įmone formą arba kai naudojatės šia svetaine, paspaudžiate bet kurį mygtuką, pažymėtą „Sutinku“ ar panašią reikšmę, arba faktiškai naudojatės šios svetainės teikiamomis paslaugomis kitais šios svetainės leidžiamais būdais. , tai reiškia, kad jūs visiškai suprantate, sutinkate ir sutinkate su visomis šios Sutarties sąlygomis. Jūsų ranka rašyto parašo nebuvimas neturės įtakos šios Sutarties teisinei galiai.",
        content20: "1.4 Tapę šios svetainės nariu, gausite nario paskyrą ir atitinkamą slaptažodį, kuriuos saugote Jūs, teisiškai atsakote už visą veiklą ir renginius, vykdomus pagal Jūsų paskyrą.",
        content21: "1.5 Tik nariai, kurie tampa šios svetainės nariais, gali naudotis šios svetainės teikiama skaitmeninio turto prekybos platforma sandoriams atlikti ir naudotis kitomis šioje svetainėje numatytomis paslaugomis, kurios yra prieinamos tik ne nariams, gali prisijungti prie svetainės, naršyti svetainėje ir kitas paslaugas, numatytas šioje svetainėje.",
        content22: "1.6 Užsiregistravę ir naudodamiesi bet kokiomis šios svetainės teikiamomis paslaugomis ir funkcijomis, bus laikoma, kad perskaitėte, supratote ir：",
        content23: "1.6.1 Sutikite su visomis šios sutarties sąlygomis。",
        content24: "1.6.2 Patvirtinate, kad esate vyresnis nei 18 metų arba turite leistiną amžių sudaryti sutartis pagal skirtingus galiojančius įstatymus. Jūsų registracija šioje svetainėje, pardavimas ar pirkimas, informacijos skelbimas ir pan. bei sutikimas su šios svetainės paslaugomis turi atitikti. turėti jurisdikciją suverenios šalies ar regiono atitinkamiems įstatymams ir reglamentams ir turėti visas galimybes sutikti su šiomis sąlygomis, sudaryti sandorius ir naudoti šią svetainę skaitmeninio turto sandoriams.。",
        content25: "1.6.3 Jūs garantuojate, kad visas jums priklausantis skaitmeninis turtas, susijęs su sandoriu, yra teisėtai įgytas ir turi nuosavybės teisę。",
        content26: "1.6.4 Jūs sutinkate, kad esate visiškai atsakingas už savo prekybinę ar neprekybinę veiklą ir bet kokį pelną ar nuostolius。",
        content27: "1.6.5 Patvirtinate, kad registruojantis pateikta informacija yra teisinga ir tiksli。",
        content28: "1.6.6 Sutinkate laikytis visų atitinkamų įstatymų reikalavimų, įskaitant ataskaitų apie prekybos pelną mokesčių tikslais pateikimą.",
        content29: "1.6.7 您同意在任何时候不得从事或参与损害本网站或公司利益的行为或活动，无论是否与本网站提供的服务有关。",
        content30: "1.6.8 Ši sutartis reglamentuoja tik teises ir pareigas tarp jūsų ir mūsų ir neapima teisinių santykių bei teisinių ginčų, kylančių dėl skaitmeninio turto sandorių tarp šios svetainės ir kitų svetainių naudotojų ir jūsų.",
        content31: "2. Sutarties pakeitimai",
        content32: "Mes pasiliekame teisę retkarčiais peržiūrėti šią Sutartį ir apie tai pranešti svetainėje, jums atskirai neįspėję. galioja, kai jis bus paskelbtas svetainėje. Retkarčiais turėtumėte naršyti ir atkreipti dėmesį į šios Sutarties atnaujinimo laiką ir atnaujintą turinį svetainė reiškia, kad sutinkate su pakeista sutartimi ir sutinkate jos laikytis.",
        content33: "3. Registracija",
        content34: "3.1 Registracijos kvalifikacija",
        content35: "Jūs patvirtinate ir pažadate, kad kai baigsite registracijos procesą arba faktiškai naudositės šios svetainės teikiamomis paslaugomis kitais šioje svetainėje leidžiamais būdais, turėtumėte turėti galimybę pasirašyti šią sutartį ir naudotis šios svetainės paslaugomis, kaip tai numato taikomi įstatymai. fizinis asmuo, juridinis asmuo ar kita organizacija. Kai paspausite mygtuką Sutinku registruotis, tai reiškia, kad jūs arba jūsų įgaliotasis atstovas sutiko su sutarties turiniu ir buvo užregistruotas bei naudotasi šios svetainės paslaugomis jo atstovo. Jei neturite aukščiau paminėtų dalykų, jūs ir jūsų įgaliotasis atstovas prisiimate visas su tuo susijusias pasekmes, o įmonė pasilieka teisę anuliuoti arba visam laikui įšaldyti jūsų paskyrą ir patraukti jus bei jūsų įgaliotąjį atstovą atsakomybėn.",
        content36: "3.2 Registracijos tikslas",
        content37: "Jūs patvirtinate ir pažadate, kad jūsų registracija šioje svetainėje nėra skirta įstatymų ir kitų teisės aktų pažeidimui arba skaitmeninio turto operacijų tvarkos šioje svetainėje trikdymui.",
        content38: "3.3 Registracijos procesas",
        content39: "3.3.1 Sutinkate pateikti galiojantį el. pašto adresą, mobiliojo telefono numerį ir kitą informaciją, kurios reikalaujama šios svetainės vartotojo registracijos puslapyje. Prisijungimui galite naudoti jūsų pateiktą ar patvirtintą el. pašto adresą, mobiliojo telefono numerį arba kitus šios svetainės leidžiamus būdus būdas patekti į šią svetainę. Jei reikia, pagal atitinkamus skirtingų jurisdikcijų įstatymus ir kitus teisės aktus, privalote pateikti savo tikrąjį vardą, pavardę, asmens dokumentą ir kitą svarbią informaciją, numatytą įstatymuose ir teisės aktuose, privatumo sąlygose ir kovos su pinigų plovimu sąlygose bei nuolat atnaujinti registracijos informaciją Reikalauti laiku, išsamiai ir tiksliai. Visa iš pradžių įvesta informacija bus nurodyta kaip registracijos informacija. Jūs atsakote už tokios informacijos tikrumą, išsamumą ir tikslumą ir prisiimate bet kokius tiesioginius ar netiesioginius nuostolius ir neigiamas pasekmes, atsirandančias dėl to.",
        content40: "3.3.2 Jei suverenios šalies ar regiono, kuriame esate, įstatymai, nuostatai, taisyklės, įsakymai ir kiti teisės aktai nustato mobiliojo telefono numerių tikrus vardus, sutinkate, kad pateiktas registruotas mobiliojo telefono numeris buvo registruotas tikruoju vardu If nepateiksite jo pagal taisykles, bet kokios jums sukeltos pasekmės bus Jūs atsakingos už visus tiesioginius ar netiesioginius nuostolius ir neigiamas pasekmes.",
        content41: "3.3.3 Jei registracijai reikalingą informaciją pateikiate teisėtai, visiškai ir veiksmingai ir ją patikrinote, turite teisę gauti šios svetainės sąskaitos numerį ir slaptažodį, kai gaunate šios svetainės sąskaitos numerį ir slaptažodį, jūsų registracija yra laikoma sėkmingai ir galite prisijungti kaip šios svetainės narys.",
        content42: "3.3.4 Jūs sutinkate gauti šios svetainės siunčiamus el. laiškus ir (arba) trumpąsias žinutes, susijusias su šios svetainės valdymu ir veikimu.",
        content43: "4. Aptarnavimas",
        content44: "Ši svetainė teikia tik internetinės prekybos platformos paslaugas, skirtas jūsų skaitmeninio turto prekybos veiklai (įskaitant, bet neapsiribojant, skaitmeninio turto prekybą ir kitas paslaugas) per šią svetainę.",
        content45: "4.1 Paslaugos turinys",
        content46: "4.1.1 Jūs turite teisę šioje svetainėje naršyti realiu laiku įvairių skaitmeninio turto produktų rinkos sąlygas ir sandorių informaciją, taip pat šioje svetainėje pateikti skaitmeninio turto sandorių instrukcijas ir užbaigti skaitmeninio turto operacijas.",
        content47: "4.1.2 Jūs turite teisę peržiūrėti savo narystės paskyroje esančią informaciją šioje svetainėje ir naudotis šios svetainės teikiamomis funkcijomis.",
        content48: "4.1.3 Jūs turite teisę dalyvauti šios svetainės organizuojamoje svetainės veikloje pagal šioje svetainėje paskelbtas veiklos taisykles.",
        content49: "4.1.4 Kitos paslaugos, kurias ši svetainė žada jums suteikti。",
        content50: "4.2 Paslaugos taisyklės Jūs įsipareigojate laikytis šių šios svetainės paslaugų taisyklių：",
        content51: "4.2.1 Jūs privalote laikytis įstatymų, taisyklių ir politikos reikalavimų, užtikrinti viso paskyroje esančio skaitmeninio turto šaltinių teisėtumą ir neužsiimti neteisėta ar kita veikla, kuri kenkia šios svetainės ar trečiųjų šalių teisėms ir interesams šioje svetainėje. arba naudodamiesi jo paslaugomis, įskaitant, bet tuo neapsiribojant: Jūs neapsiribojate neteisėtos, neteisėtos ar kitų teises pažeidžiančios informacijos siuntimu ar gavimu, piramidžių schemų ar kitos žalingos informacijos ar pastabų siuntimu ar gavimu, el. pašto naudojimu ar klastojimu. antraštės informacija šioje svetainėje be leidimo iš šios svetainės ir pan.",
        content52: "4.2.2 Turėtumėte laikytis įstatymų ir teisės aktų bei tinkamai naudoti ir saugoti savo sąskaitos numerį, prisijungimo slaptažodį, fondo slaptažodį, mobiliojo telefono numerį, susietą su jumis registruojantis, ir mobiliojo telefono patvirtinimo kodą, gautą iš jūsų mobiliojo telefono. Jūs esate visiškai atsakingas už visas operacijas ir pasekmes, susijusias su paskyros ir prisijungimo slaptažodžio, fondo slaptažodžio ir mobiliojo telefono patvirtinimo kodo naudojimu. Kai nustatote, kad šios svetainės sąskaitos numerį, prisijungimo slaptažodį arba lėšų slaptažodį ar patvirtinimo kodą naudoja trečioji šalis be jūsų leidimo, arba jei kyla kitų paskyros saugumo problemų, turėtumėte nedelsdami ir veiksmingai pranešti šiai svetainei ir paprašyti šios svetainės sustabdyti. šios svetainės paskyros paslauga. Ši svetainė turi teisę imtis veiksmų pagal jūsų prašymą per protingą laiką, tačiau ši svetainė neprisiima jokios atsakomybės už pasekmes (įskaitant, bet neapsiribojant, bet kokius jūsų patirtus nuostolius), atsiradusias prieš imantis veiksmų. Jūs negalite dovanoti, skolintis, išnuomoti, perleisti ar kitaip disponuoti savo paskyra šioje svetainėje kitiems be šios svetainės sutikimo.",
        content53: "4.2.3 Jūs sutinkate būti atsakingas už visą veiklą, kuri atliekama naudojant jūsų paskyrą ir slaptažodį šioje svetainėje (įskaitant, bet neapsiribojant, informacijos atskleidimą, informacijos paskelbimą, internetinius paspaudimus, kad sutiktumėte arba įvairių taisyklių ir susitarimų pateikimą, sutarčių atnaujinimą internetu arba pirkimą). paslaugas ir pan.).",
        content54: "4.2.4 Vykdydami skaitmeninio turto operacijas šioje svetainėje, jūs neturite piktybiškai kištis į normalią skaitmeninio turto operacijų eigą arba sutrikdyti operacijų eiliškumą, netrukdyti normaliai šios svetainės veikimui ar trukdyti kitiems naudotojams naudotis šia svetaine paslaugas jokiomis techninėmis ar kitomis priemonėmis neturite naudoti fiktyvių Piktybiškai šmeižti šios svetainės gerą valią faktais ir kitomis priemonėmis.",
        content55: "4.2.5 Jei kyla ginčų su kitais vartotojais dėl internetinių sandorių, negalite prašyti šios svetainės neteisminiais ar administraciniais kanalais pateikti atitinkamą informaciją.",
        content56: "4.2.6 Jūs tik spręsite ir padengsite visus mokėtinus mokesčius, taip pat visas techninės, programinės įrangos, paslaugų ir kitas išlaidas, patirtas naudojantis šios svetainės teikiamomis paslaugomis.",
        content57: "4.2.7 Jūs turėtumėte laikytis šios sutarties ir kitų paslaugų sąlygų bei veiklos taisyklių, kurias retkarčiais skelbia ir atnaujina ši svetainė, ir turite teisę bet kuriuo metu nutraukti naudojimąsi šios svetainės teikiamomis paslaugomis.",
        content58: "4.3 gaminio taisyklės",
        content59: "4.3.1 Naršyti operacijų informaciją",
        content60: "Naršydami šioje svetainėje informaciją apie sandorius, turėtumėte atidžiai perskaityti visą informaciją apie sandorį, įskaitant kainą, komisinių mastą, tvarkymo mokestį, pirkimo ar pardavimo kryptį, bet tuo neapsiribojant, ir tik tada, kai visiškai sutinkate su visu sandorio informacija Sandoriai gali būti sudaromi vienu mygtuko paspaudimu.",
        content61: "4.3.2 Peržiūrėkite išsamią operacijos informaciją",
        content62: "Atitinkamus operacijų įrašus galite peržiūrėti savo paskyroje。",
        content63: "5. Šios svetainės teisės ir pareigos",
        content64: "5.1 Jei neturite šioje sutartyje numatytų registracijos sąlygų, ši svetainė turi teisę atmesti jūsų registraciją jūsų įgaliotas atstovas yra atsakingas. Tuo pat metu ši svetainė pasilieka teisę nuspręsti, ar priimti jūsų registraciją kitomis aplinkybėmis.",
        content65: "5.2 Remiantis pačios šios svetainės nuomone, jei ši svetainė nustato, kad jūs ar jūsų susijusių paskyros naudotojai netinkami didelės rizikos investicijoms, mes turime teisę sustabdyti arba nutraukti jūsų paskyrą ir visų susijusių paskyrų naudojimą.",
        content66: "5.3 Kai ši svetainė nustato, kad paskyros vartotojas nėra pirmasis paskyros registruotojas, ji turi teisę sustabdyti arba nutraukti paskyros naudojimą.",
        content67: "5.4 Kai ši svetainė pagrįstai įtaria, kad jūsų pateikta informacija yra neteisinga, netikra, neteisinga arba neišsami, taikant techninius bandymus, rankinį mėginių ėmimą ir kitus testavimo būdus, ji turi teisę įspėti jus, kad ištaisytumėte ar atnaujintumėte informaciją arba sustabdytumėte ar nutrauktumėte informacijos teikimą. šios svetainės paslaugos jums.",
        content68: "5.5 Ši svetainė pasilieka teisę pataisyti bet kokią šioje svetainėje pateiktą informaciją, kai nustatoma, kad yra akivaizdi klaida.",
        content69: "5.6 Ši svetainė pasilieka teisę bet kuriuo metu keisti, sustabdyti arba nutraukti šios svetainės paslaugas interneto svetainėje, nutraukimas bus iš šios svetainės svetainėje, įsigalioja pranešimo apie nutraukimą paskelbimo dieną.",
        content70: "5.7 Ši svetainė imsis reikiamų techninių priemonių ir valdymo priemonių, kad užtikrintų normalų šios svetainės veikimą, užtikrintų reikiamą ir patikimą prekybos aplinką ir prekybos paslaugas bei palaikytų skaitmeninio turto operacijų tvarką.",
        content71: "5.8 Jei vienerius metus iš eilės neprisijungsite prie šios svetainės naudodami savo narystės paskyrą ir slaptažodį, ši svetainė turi teisę atšaukti jūsų paskyrą. Panaikinus paskyrą, ši svetainė turi teisę atverti atitinkamą nario vardą kitiems vartotojams registracijai ir naudojimui.",
        content72: "5.9 Ši svetainė užtikrina jūsų skaitmeninio turto saugumą stiprindama investicijas į technologijas, gerindama saugumo priemones ir kitas priemones bei iš anksto įspės jus, kai jūsų paskyroje iškils numatomos saugumo rizikos.",
        content73: "5.10 Ši svetainė turi teisę bet kuriuo metu ištrinti bet kokią informaciją apie turinį, kuri neatitinka įstatymų ir taisyklių arba šios svetainės nuostatų.",
        content74: "5.11 Ši svetainė turi teisę prašyti jūsų pateikti daugiau informacijos ar medžiagos pagal jūsų suverenios šalies ar regiono įstatymus, taisykles, įsakymus ir kitus reguliavimo reikalavimus bei imtis pagrįstų priemonių, kad būtų laikomasi vietinių reguliavimo reikalavimų yra įpareigoti bendradarbiauti, ši svetainė turi teisę sustabdyti arba visam laikui sustabdyti kai kurių ar visų šios svetainės paslaugų teikimą jums pagal jūsų suverenios šalies ar regiono įstatymų, taisyklių, įsakymų ir kitų specifikacijų reikalavimus.",
        content75: "5.12 Ši svetainė pasilieka teisę savo nuožiūra uždaryti jūsų paskyrą, įspėjusi prieš septynias darbo dienas. Todėl turite septynias darbo dienas atšaukti užsakymus ir uždaryti pozicijas. Jei neatšaukėte užsakymo ir neuždarėte pozicijos pasibaigus terminui, mes priverstinai atšauksime užsakymą ir uždarysime poziciją, o likusį skaitmeninį turtą jūsų paskyroje grąžinsime jums.",
        content76: "5.13 Siekdama apsaugoti prekybininkų teises ir interesus, ši svetainė turi teisę koreguoti internetinius produktus esant ypatingoms aplinkybėms (pavyzdžiui, sistemos gedimas, tinklo gedimas, ekstremalios rinkos sąlygos ir kt.), pvz.: sutartys dėl išankstinio pristatymo ir atsiskaitymas, sutarčių tipai ir išankstinio pristatymo bei atsiskaitymo sutartys apie laikotarpį ir atsiskaitymą bei pristatymo kainą skelbiama šioje svetainėje.",
        content77: "6. Kompensacija",
        content78: "6.1 Jokiu būdu mūsų atsakomybė jums už tiesioginę žalą neviršys bendrų paslaugų mokesčių, kuriuos apmokestinome už naudojimąsi šia svetaine trijų (3) mėnesių laikotarpiu.",
        content79: "6.2 Jei pažeidžiate šią Sutartį ar kitus įstatymus ir kitus teisės aktus, turite mums kompensuoti bent 2 milijonus JAV dolerių ir padengti visas patirtas išlaidas (įskaitant advokato mokesčius ir pan. Jei to nepakanka faktiniams nuostoliams kompensuoti, turite tai padaryti). už tai.",
        content80: "7. Teisė reikalauti, kad būtų panaikinta teisinė pagalba",
        content81: "Mes ir jūs abu pripažįstame, kad bendrosios teisės gynimo priemonių, susijusių su jūsų sutarties pažeidimu arba galimu sutarties pažeidimu, gali nepakakti kompensuoti visus mūsų patiriamus nuostolius, todėl turime teisę prašyti uždraudimo, kaip tai leidžia bendroji teisė arba teisingumas. jūsų sutarties pažeidimo ar galimo sutarties pažeidimo atveju.",
        content82: "8. Atsakomybės apribojimas ir atsakomybės atsisakymas",
        content83: "8.1 Jūs suprantate ir sutinkate, kad jokiomis aplinkybėmis nebūsime atsakingi už toliau nurodytus dalykus：",
        content84: "8.1.1 negautų pajamų；",
        content85: "8.1.2 Prekybos pelnas arba sutarties nuostoliai；",
        content86: "8.1.3 Nuostoliai dėl verslo nutraukimo；",
        content87: "8.1.4 Tikėtinų piniginių santaupų praradimas；",
        content88: "8.1.5 Nuostoliai dėl informacijos problemų；",
        content89: "8.1.6 Galimybių, geros valios ar reputacijos praradimas；",
        content90: "8.1.7 Duomenų sugadinimas arba praradimas；",
        content91: "8.1.8 Pakaitinių produktų ar paslaugų pirkimo išlaidos；",
        content92: "8.1.9 Bet kokie netiesioginiai, specialūs ar atsitiktiniai nuostoliai ar žala, atsirandanti dėl delikto (įskaitant aplaidumą), sutarties pažeidimo ar bet kokios kitos priežasties, neatsižvelgiant į tai, ar mes tokius nuostolius ar žalą galime pagrįstai numatyti, ar ne, ar buvome informuoti apie tai, ar ne iš anksto Galimybė prarasti ar sugadinti.",
        content93: "8.1.1 8.1.9 straipsniai yra nepriklausomi vienas nuo kito.",
        content94: "8.2 Jūs suprantate ir sutinkate, kad mes nebūsime atsakingi už jokią žalą, padarytą jums dėl bet kurios iš šių aplinkybių:：",
        content95: "8.2.1 Jūsų konkretūs sandoriai gali būti susiję su dideliais įstatymų arba sutarties pažeidimais。",
        content96: "8.2.2 Įtariama, kad jūsų elgesys šioje svetainėje yra neteisėtas arba amoralus。",
        content97: "8.2.3 Išlaidos ir nuostoliai, patirti perkant ar gavus bet kokius duomenis, informaciją ar atliekant sandorius naudojantis šios svetainės paslaugomis arba atliekant pakaitinius veiksmus.",
        content98: "8.2.4 Jūsų nesusipratimas dėl šios svetainės paslaugų。",
        content99: "8.2.5 Bet kokius kitus nuostolius, susijusius su šios svetainės teikiamomis paslaugomis, kuriuos sukėlė ne mes。",
        content100: "8.3 Esame atsakingi už informacinio tinklo įrangos priežiūrą, informacinio tinklo ryšio sutrikimą, kompiuterio, ryšio ar kitos sistemos gedimą, elektros energijos tiekimo sutrikimą, oro sąlygas, avarijas, streikus, darbo ginčus, riaušes, sukilimus, riaušes, nepakankamą produktyvumą ar gamybines medžiagas, gaisrą, potvynius. , audros, sprogimai, karai, banko ar kitos partnerių priežastys, skaitmeninio turto rinkos žlugimas, vyriausybės veiksmai, teismų ar administracinių agentūrų nurodymai, kiti veiksmai, kurių mes negalime kontroliuoti arba kurių negalime kontroliuoti, arba trečiųjų šalių priežastys. neprisiima jokios atsakomybės už nesugebėjimą ar vėlavimą suteikti paslaugą arba savo nuostolius.",
        content101: "8.4 Negalime garantuoti, kad visa šioje svetainėje esanti informacija, programos, tekstai ir kt. yra visiškai saugūs ir jų netrukdys ir nesunaikins jokie virusai, Trojos arkliai ir kitos kenkėjiškos programos Šią svetainę ar atsisiųsti ir naudoti bet kokias atsisiųstas programas, informaciją, duomenis ir tt yra jūsų pačių sprendimai ir jūs prisiimate riziką bei galimus nuostolius savo rizika.",
        content102: "8.5 Mes neprisiimame jokių garantijų ar įsipareigojimų dėl bet kokios trečiųjų šalių svetainių, susietų su šia svetaine, informacijos, produktų ir paslaugų ar bet kokio kito turinio, kuris mums nepriklauso, jei naudojatės kokiomis nors trečiųjų šalių teikiamomis paslaugomis, informacija ir paslaugomis - Šalių svetainės, Produktai ir tt yra jūsų pačių sprendimai ir jūs prisiimate visą su tuo susijusią atsakomybę.",
        content103: "8.6 Mes nesuteikiame jokių aiškių ar numanomų garantijų, kad naudojatės šioje svetainėje teikiamomis paslaugomis, įskaitant, bet neapsiribojant, šioje svetainėje teikiamų paslaugų tinkamumą, klaidų ar praleidimų nebuvimą, tęstinumą, tikslumą, patikimumą ir tinkamumą konkrečiam tikslui. tikslas. Tuo pačiu metu mes neprisiimame jokių įsipareigojimų ar garantijų dėl technologijos ir informacijos, susijusios su šios svetainės teikiamomis paslaugomis, galiojimo, tikslumo, teisingumo, patikimumo, kokybės, stabilumo, išsamumo ir savalaikiškumo. Ar prisijungti, ar naudotis šios svetainės teikiamomis paslaugomis, yra jūsų asmeninis sprendimas ir jūs prisiimate savo riziką bei galimus nuostolius. Mes nesuteikiame jokių aiškių ar numanomų garantijų dėl skaitmeninio turto rinkos, vertės ir kainos savo asmeninę laisvę rinkitės ir spręskite prisiimdami riziką ir galimus nuostolius.",
        content104: "8.7 Mūsų garantijos ir įsipareigojimai, išdėstyti šioje Sutartyje, yra vienintelės mūsų garantijos ir pareiškimai, susiję su šia Sutartimi ir šioje svetainėje teikiamomis paslaugomis, ir pakeičia visas garantijas ir įsipareigojimus, atsirandančius bet kokiu kitu būdu ir būdu, nesvarbu, ar raštu, ar žodžiu, aiškiai išreikštu. arba numanoma. Visos šios garantijos ir pareiškimai reiškia tik mūsų įsipareigojimus ir garantijas ir negarantuoja, kad bet kuri trečioji šalis laikysis šioje Sutartyje nustatytų garantijų ir įsipareigojimų.",
        content105: "8.8 Mes neatsisakome jokių šioje Sutartyje nenurodytų teisių apriboti, pašalinti ar kompensuoti savo atsakomybę už žalą, kiek tai taikoma pagal galiojančius įstatymus.",
        content106: "8.9 Užsiregistravę sutinkate su bet kokiomis operacijomis, kurias atliekame pagal šioje sutartyje nustatytas taisykles, ir bet kokią riziką prisiimate jūs.",
        content107: "9. Sutarties nutraukimas",
        content108: "9.1 Ši svetainė turi teisę nutraukti visas šios svetainės paslaugas pagal šią sutartį. Ši sutartis bus nutraukta tą dieną, kai bus nutrauktos visos šios svetainės paslaugos.",
        content109: "9.2 Nutraukus šią Sutartį, jūs neturite teisės reikalauti, kad ši svetainė ir toliau teiktų jai kokias nors paslaugas ar vykdytų bet kokius kitus įsipareigojimus, įskaitant, bet tuo neapsiribojant, reikalavimą, kad ši svetainė saugotų arba atskleistų jums bet kokią informaciją savo pradinėje svetainės paskyroje. Jums arba trečiajai šaliai, trečioji šalis persiunčia bet kokią informaciją, kurios ji neperskaitė ar neišsiuntė.",
        content110: "9.3 Šios sutarties nutraukimas neturės įtakos kitoms sutarties nepažeidžiančios šalies įsipareigojimams pažeidusiai šaliai.",
        content111: "10. Intelektinės nuosavybės teisės",
        content112: "10.1 Visi intelektiniai laimėjimai, esantys šioje svetainėje, apima, bet tuo neapsiribojant ) Programų ir scenarijų intelektinės nuosavybės teisės priklauso šiai svetainei. Jūs negalite atgaminti, keisti, kopijuoti, siųsti ar naudoti bet kokios anksčiau pateiktos medžiagos ar turinio komerciniais tikslais.",
        content113: "10.2 Visos teisės, esančios šios svetainės pavadinime (įskaitant, bet neapsiribojant, prestižą ir prekių ženklus, logotipus) priklauso įmonei.",
        content114: "10.3 Jūsų sutikimas su šia sutartimi bus laikomas jūsų iniciatyva perduoti bet kokios formos informacijos, kurią skelbiate šioje svetainėje, autorių teises, įskaitant, bet neapsiribojant: atgaminimo teises, platinimo teises, nuomos teises, eksponavimo teises, atlikimo teises, peržiūros teises, transliavimo teisės, informacijos perdavimo internetu teisės, filmavimo teisės, pritaikymo teisės, vertimo teisės, kompiliavimo teisės ir kitos perleidžiamos teisės, kuriomis turėtų naudotis autorių teisių turėtojas, yra išimtinai perduodamos šiai svetainei. Ši svetainė turi teisę pateikti nepriklausomą pareikšti ieškinį bet kuriam subjektui dėl pažeidimo ir gauti visą kompensaciją. Ši sutartis galioja bet kokiam autorių teisių įstatymų saugomam kūriniui, kurį skelbiate šioje svetainėje, nesvarbu, ar turinys suformuotas iki šios sutarties pasirašymo, ar po šios sutarties pasirašymo.",
        content115: "10.4 Naudodamiesi šios svetainės paslaugomis, negalite neteisėtai naudotis arba disponuoti šios svetainės ar kitų intelektinės nuosavybės teisėmis. Jūs negalite skelbti ar leisti kitoms svetainėms (ir žiniasklaidos priemonėms) bet kokia forma naudoti šioje svetainėje paskelbtos informacijos.",
        content116: "11. Informacijos apsauga",
        content117: "Pirmenybę teikia šioje svetainėje atskirai paskelbtų „Privatumo sąlygų“ nuostatos.",
        content118: "12. Skaičiavimas",
        content119: "Visi sandorių skaičiavimo rezultatai buvo mūsų patikrinti, visi skaičiavimo metodai buvo paskelbti svetainėje, tačiau negalime garantuoti, kad naudojimasis svetaine nebus pertraukiamas ar be klaidų.",
        content120: "13. Eksporto kontrolė",
        content121: "Jūs suprantate ir pripažįstate, kad pagal atitinkamus įstatymus jums neleidžiama eksportuoti, reeksportuoti, importuoti ar perkelti jokios medžiagos (įskaitant programinę įrangą) šioje svetainėje, todėl garantuojate, kad aktyviai neįgyvendinsite, nepadėsite ar nedalyvausite aukščiau paminėtą eksportą ar susijusią veiklą, kuri pažeidžia įstatymus ir kitus teisės aktus, jei tokia situacija aptinkama, turėtumėte apie tai mums laiku pranešti ir padėti ją išspręsti.",
        content122: "14. Perdavimas",
        content123: "Šioje Sutartyje numatytos teisės ir pareigos taip pat saistomos šalių, kurios naudojasi tokiomis teisėmis ir pareigomis, perėmėjams, įpėdiniams, vykdytojams ir administratoriams. Negalite jos perduoti jokiai trečiajai šaliai be mūsų sutikimo, tačiau mes galime bet kada perduoti savo teises ir įsipareigojimus pagal šią Sutartį bet kuriai trečiajai šaliai ir pranešti apie tai.",
        content124: "15. Dalomumas",
        content125: "Jei kuri nors šios Sutarties nuostata bet kurio kompetentingos jurisdikcijos teismo bus pripažinta neįgyvendinama, negaliojančia ar neteisėta, tai neturės įtakos likusių šios Sutarties nuostatų galiojimui.",
        content126: "16. Ne agentūriniai santykiai",
        content127: "Nelaikoma, kad jokia šios Sutarties nuostata sukuria, numano ar kitaip nelaiko mus jūsų agentu, patikėtiniu ar kitu atstovu, nebent šioje Sutartyje numatyta kitaip.",
        content128: "17. Susilaikymas",
        content129: "Mūsų ar jūsų bet kurios šalies atsakomybės už sutarties pažeidimą ar kitos atsakomybės, numatytos šioje Sutartyje, atsisakymas negali būti laikomas ir interpretuojamas kaip kitos atsakomybės už sutarties pažeidimą atsisakymas gali būti suprantamas kaip atsisakymas nuo tokių teisių ar teisių gynimo priemonių.",
        content130: "18. Pavadinimas",
        content131: "Visos antraštės skirtos tik susitarimo išraiškos patogumui ir nenaudojamos siekiant išplėsti ar apriboti sutarties sąlygų turinį ar apimtį.",
        content132: "19. Taikytina teisė",
        content133: "19.1 Prieš keldami ginčą ar pretenziją, jūs pripažįstate ir sutinkate pirmiausia susisiekti su šia svetaine el. paštu, kad ginčas būtų išspręstas neoficialiai. Mes stengsimės kuo greičiau išspręsti jūsų ginčą sąžiningų derybų (diskusijų) būdu yra konfidencialios ir saugomos pagal galiojančias taisykles ir nenaudojamos kaip įrodymas jokiuose teisminiuose procesuose).",
        content134: "19.2 Jūs pripažįstate ir sutinkate, kad kilus bet kokiam ginčui, nesutarimui, nesutarimui ar pretenzijai, įskaitant šių Sąlygų egzistavimą, galiojimą, aiškinimą, vykdymą, pažeidimą ar nutraukimą arba bet kokį ginčą, kylantį iš šių Sąlygų arba susijusių su jomis („Ginčas“). ), aukščiau nurodytos šalys perduoda ginčą Tarptautinių prekybos rūmų Tarptautiniam arbitražo teismui (toliau – ICC tarptautinis arbitražo teismas), vadovaudamosi tuo metu galiojusiomis „ICC Arbitražo taisyklėmis“. Arbitražo vieta yra Belizas, o taikytina arbitražo teisė nustatoma pagal Tarptautinių prekybos rūmų arbitražo taisykles. Jeigu šalys nesusitaria kitaip, pagal TBT arbitražo taisykles bus skiriamas tik vienas arbitras. Arbitras turi išimtinę teisę priimti sprendimą dėl savo jurisdikcijos, įskaitant, bet neapsiribojant, bet kokius prieštaravimus dėl arbitražinio susitarimo egzistavimo, taikymo srities ar galiojimo arba bet kokio reikalavimo ar priešpriešinio reikalavimo arbitražo. Bet koks arbitražas vyks anglų kalba. Nepriklausomai nuo to, kaip vyksta arbitražas, arbitras priima rašytinį sprendimą, kuris yra pagrįstas ir pakankamas, kad paaiškintų sprendimą ir esmines išvadas, jei tokių yra, kuriomis grindžiamas sprendimas. Arbitražo sprendimas yra galutinis, šalims privalomas ir gali būti vykdomas bet kuriame kompetentingos jurisdikcijos teisme.",
        content135: "20. Sutarties veiksmingumas ir aiškinimas",
        content136: "20.1 Ši sutartis įsigalioja, kai spustelėsite šios svetainės registracijos puslapį, kad sutinkate užsiregistruoti, užbaigti registracijos procesą ir gauti šios svetainės paskyrą bei slaptažodį. Ji yra privaloma ir šiai svetainei, ir jums.",
        content137: "20.2 Galutinė šios sutarties aiškinimo teisė priklauso šiai svetainei.",
        content138: "Žinokite savo klientų ir pinigų plovimo prevencijos politiką",
        content139: "1. Įvadas",
        content140: "1.1 Pažadame atidžiai laikytis įstatymų ir kitų teisės aktų, susijusių su „Pažink savo klientą“ ir kova su pinigų plovimu, ir tyčia nepažeisime „Pažink savo klientą ir kovos su pinigų plovimu politikos“. Savo pagrįstos kontrolės ribose imsimės reikiamų priemonių ir technologijų, kad galėtume teikti jums saugias paslaugas ir kiek įmanoma labiau apsaugoti jus nuo nuostolių, kuriuos sukelia nusikalstama veika įtariamų asmenų pinigų plovimo elgesys.",
        content141: "1.2 Mūsų „Pažink savo klientą“ ir Kovos su pinigų plovimu politika yra išsami tarptautinė politikos sistema, apimanti „Pažink savo klientą“ ir kovos su pinigų plovimu politiką, skirtą skirtingoms teisinėms jurisdikcijoms, su kuriomis esate susiję.",
        content142: "2. Žinokite savo klientų ir pinigų plovimo prevencijos politiką：",
        content143: "2.1 Paskelbkite savo kliento pažinimo ir kovos su pinigų plovimu politiką ir retkarčiais ją atnaujinkite, kad atitiktų galiojančių įstatymų ir kitų teisės aktų nustatytus standartus.；",
        content144: "2.2 Paskelbkite ir atnaujinkite kai kuriuos pagrindinius šios svetainės veikimo principus ir taisykles, o mūsų darbuotojai teiks paslaugas pagal šių principų ir taisyklių gaires.；",
        content145: "2.3 Sukurti ir užbaigti vidines operacijų stebėjimo ir kontrolės procedūras, tokias kaip griežtas tapatybės tikrinimas ir profesionalios komandos, atsakingos už kovos su pinigų plovimu, formavimo organizavimas.；",
        content146: "2.4 Taikyti rizikos prevencijos metodą, kad būtų atliktas deramas klientų patikrinimas ir nuolatinė priežiūra；",
        content147: "2.5 Peržiūrėkite ir reguliariai tikrinkite įvykusias operacijas；",
        content148: "2.6 Praneškite apie įtartinus sandorius kompetentingoms institucijoms；",
        content149: "2.7 Asmens tapatybę patvirtinantys dokumentai, adreso dokumentai ir operacijų įrašai bus saugomi mažiausiai šešerius metus ir gali būti pateikti reguliavimo institucijoms be papildomo įspėjimo.",
        content150: "3. Tapatybės informacija ir patikrinimas",
        content151: "3.1 Tapatybės informacija",
        content152: "3.1.1 Pagal skirtingus teisės aktus įvairiose jurisdikcijose ir skirtingų tipų subjektuose mūsų renkamos informacijos turinys iš esmės bus renkamas iš registruotų asmenų.：",
        content153: "Pagrindinė asmeninė informacija: jūsų vardas, pavardė, adresas (ir nuolatinis adresas, jei skiriasi), gimimo data ir pilietybė bei kita turima informacija. Asmens tapatybės patvirtinimas turėtų būti pagrįstas oficialių ar kitų panašių institucijų išduotais dokumentais, tokiais kaip pasai, asmens tapatybės kortelės ar kiti tapatybės dokumentai, kurių reikalaujama ir kuriuos nustato skirtingos jurisdikcijos. Jūsų nurodytas adresas bus patikrintas naudojant atitinkamus metodus, pavyzdžiui, patikrinus keleivinio transporto bilietą ar palūkanų normą arba patikrinus rinkėjų registrą.",
        content154: "Galiojanti nuotrauka: prieš registruodamiesi turite pateikti savo nuotrauką, kurioje laikote asmens dokumentą prie krūtinės；",
        content155: "Kontaktiniai duomenys: telefono / mobiliojo telefono numeris ir (arba) galiojantis el. pašto adresas.",
        content156: "3.1.2 Jei esate korporacija ar kitas juridinis asmuo, mes rinksime toliau nurodytą informaciją, kad galėtume identifikuoti jus arba galutinį jūsų pasitikėjimo sąskaitos gavėją.",
        content157: "Įmonės įstatų ir memorandumo, patvirtinančios įmonės nuosavybės struktūrą, kopijas, įrodančius įgaliotojo atstovaujamojo valdybos nutarimą, kuris lemia sąskaitos atidarymą ir vykdymą šioje įmonėje; direktoriai, kuriuos reikia pateikti pagal poreikį, pagrindinio akcininko ir asmens, įgalioto pasirašyti sąskaitą šioje svetainėje, tapatybę patvirtinančius dokumentus, jei jis skiriasi nuo bendrovės pašto adreso, nurodykite pašto adresą. Jei įmonės vietinis adresas nesutampa su pagrindiniu įmonės adresu, ji laikoma didesnės rizikos klientu ir turės pateikti papildomus dokumentus.",
        content158: "Atsižvelgdami į skirtingus reglamentus įvairiose jurisdikcijose ir skirtingų tipų subjektuose, mums reikia kitų institucijų išduotų sertifikatų ir dokumentų, taip pat dokumentų, kuriuos laikome reikalingais.",
        content159: "3.1.3 Priimame tik anglų arba kinų tapatybės informacijos versijas. Jei ne, išverskite savo tapatybės informaciją į anglų kalbą ir patvirtinkite ją notaro.",
        content160: "3.2 Patvirtinkite patvirtinimą",
        content161: "3.2.1 Visas puslapio turinys, kuriame prašome pateikti asmens tapatybę patvirtinančius dokumentus。",
        content162: "3.2.2 Prašome pateikti nuotrauką, kurioje laikote asmens dokumentą prie krūtinės。",
        content163: "3.2.3 Patvirtinamųjų dokumentų kopijos paprastai turi būti sulygintos su čekių originalais. Tačiau kopija yra priimtina, jei tinkamas ir patikimas sertifikuotojas gali patvirtinti, kad kopija yra tiksli ir išsami originalaus dokumento kopija. Tokie sertifikuotojai yra ambasadoriai, teismų komisarai, vietos magistratai ir kt.",
        content164: "3.2.4 Reikalavimas nustatyti galutinį naudos gavėją ir sąskaitos kontrolę – nustatyti, kurie asmenys galiausiai priklauso tiesioginiam klientui arba jį kontroliuoja, ir (arba) nustatyti, kad vykdomos operacijos vykdomos kitų vardu. Jei tai verslas, turėtų būti patikrinta pagrindinių akcininkų tapatybė (pavyzdžiui, turinčių 10 % ar daugiau balsavimo akcijų). Paprastai 25 % akcijų turėjimas bus laikomas normalia rizika, o akcininko tapatybė turi būti patikrinta, turintis 10 % akcijų arba turintis daugiau balsavimo teisių ar akcijų, ir yra laikoma didelės rizikos situacija; akcininkas turi būti patikrintas.",
        content165: "4. Stebėkite sandorius",
        content166: "4.1 Retkarčiais nustatome ir koreguojame maksimalius dienos operacijų ir valiutos išėmimo limitus, atsižvelgdami į saugumą ir faktines operacijos sąlygas.;",
        content167: "4.2 Jei registruoto vartotojo sandoriai įvyksta dažnai arba yra nepagrįstų aplinkybių, mūsų profesionali komanda įvertins ir nuspręs, ar jie yra įtartini.;",
        content168: "4.3 Jei pagal savo sprendimą nustatome, kad sandoris yra įtartinas, galime imtis ribojančių priemonių, pvz., sustabdyti sandorį, atmesti sandorį arba net kuo greičiau atšaukti sandorį ir pranešti apie tai kompetentingai institucijai, tačiau jums nepraneš.;",
        content169: "4.4 Mes pasiliekame teisę atmesti registracijos paraiškas iš jurisdikcijų, kurios neatitinka tarptautinių kovos su pinigų plovimu standartų, arba asmenų, kurie gali būti laikomi politiškai pažeidžiamais asmenimis bet kuriuo metu, bet mes to nepažeidžiame jūsų įsipareigojimų ar įsipareigojimų jums.",
    },
    register: {
        emailRegister: "paštu registracija",
        phoneRegister: "Užregistruokite savo telefoną",
        formTitle1: "sukurti",
        formTitle2: "Registruokitės naudodami savo el. pašto adresą arba mobiliojo telefono numerį",
        formTitle3: "sąskaita",
        field1: "Patvirtinimo kodas",
        field2: "Gauti",
        field3: "Patvirtinti slaptažodį",
        field4: "Pakvietimo kodas",
        field41: "（Neprivaloma）",
        field5: "Perskaiciau ir sutinku",
        field6: "Paslaugų teikimo sąlygos",
        placeholder1: "įveskite patvirtinimo kodą",
        content7: "įveskite patvirtinimo kodą",
        content12: "Įveskite telefono numerį",
        content13: "Įveskite slaptažodį",
        content14: "prašome įvesti savo el",
        content18: "Dar kartą įveskite slaptažodį",
        content19: "Sutikite su paslaugų teikimo sąlygomis",
        content20: "Įveskite teisingą patvirtinimo kodą",
        content23: "Vis dar negavote patvirtinimo kodo?",
        content24: "Toliau įveskite patvirtinimo kodą",
        registerSuccess: "Registracija sėkminga",
        content25: "Slaptažodžiai nenuoseklūs",
        content26: "Įveskite teisingą el. pašto adresą",
        content27: "Slaptažodžio nustatymas iš naujo sėkmingas"
    },
    download: {
        content1: "Prekiaukite bet kada ir bet kur",
        content2: "Puikiai suderinamas su keliais terminalais, bet kuriuo metu tenkinantis įvairių scenarijų operacijų poreikius",
        content3: "Patikrinkite realiojo laiko rinkos sąlygas bet kuriuo metu",
        content4: "Lengvai pirkite ir parduokite BTC, ETH, XRP ir kitą skaitmeninį turtą",
        content5: "Gaukite išankstinius įspėjimus apie jums svarbių kriptovaliutų kainų pokyčius",
        content6: "Peržiūrėkite Bitcoin neatidėliotinų paskolų, ateities paskolų ir pasirinkimo sandorių kainas",
        content7: "Palyginkite kriptovaliutų kainas įvairiose biržose",
        title: "parsisiųsti",
        install: "Diegimo pastabos",
        one: "1、Leisti atsisiųsti aprašo failus",
        two: "2、Aprašymo failas atsisiųstas",
        three: "3、Telefone eikite į [Nustatymai] ir raskite [Bendra]",
        four: "4、Profiliai ir įrenginių tvarkytuvė",
        five: "5、Spustelėkite profilį",
    },
    identity: {
        noAuthentication: {
            title: "Jaunesniojo pažymėjimas",
            pleaseSelectYourCountry: "Prašome pasirinkti savo šalįl",
            name: "vardas",
            enterName: "įveskite savo vardą",
            city: "miestas",
            enterCity: "Įveskite savo miestą",
            IDNumber: "asmens tapatybės dokumento numeris",
            enterIDNumber: "Įveskite savo ID numerį",
        },
        noAdvancedAuthentication: {
            title: "Išplėstinis sertifikavimas",
            infoCountry: "šalis / regionas",
            infoName: "vardas",
            infoNumber: "asmens tapatybės dokumento numeris",
            infoAddress: "adresu",
        },
        text: "nesertifikuotas",
        recertification: "pakartotinis sertifikavimas",
        certification: "Sertifikavimas",
        authenticationInProgress: "patikrinta",
        inAuthentication: "Vykdomas sertifikavimas",
        uploadTheFrontOfTheDocument: "Įkelkite priekinę asmens tapatybės dokumento dalį",
        uploadTheReverseSideOfTheDocument: "Įkelkite kitą sertifikato pusę",
        uploadAPhotoOfAHandHeldID: "Įkelkite asmens tapatybės dokumento nuotrauką",
        pleaseUpload: "Prašau ",
        pleaseCompleteOrdinaryCertificationFirst: "Reikia palaukti, kol bus sėkminga pirminė sertifikavimo peržiūra",
        refused: "Atstumtas",
        reason: "priežastis",
        succeeded: "pavyko",
        uploading: "įkėlimas",
        newTitle: "Pasirinkite šalį, kurioje buvo išduotas jūsų ID",
        pleaseOrdinaryCertificationFirst: "Pirmiausia atlikite pirminį sertifikavimą",
        text1: "Keisti avatarą",
        text2: "Slapyvardis",
        text3: "sąskaitą",
        text4: "Slapyvardžio modifikavimas",
        text5: "naujas slapyvardis",
        text6: "Įveskite savo naują slapyvardį",
        text7: "Senas slaptažodis",
        text8: "Įveskite seną slaptažodį",
        text9: "Naujas Slaptažodis",
        text10: "Įveskite naują slaptažodį",
        text11: "Patvirtinti slaptažodį",

        text12: "Dar kartą įveskite naują slaptažodį",
        text13: "nauja pašto dėžutė",
        text14: "Patvirtinimo kodas",
        text15: "įveskite patvirtinimo kodą",
        text16: "savo mobiliojo telefono numerį",
        text17: "Naujas mobiliojo telefono numeris",
        text18: "prašome įvesti savo telefono numerį",
        text19: "Mobiliojo telefono patvirtinimo kodas",
        text20: "Jaunesniojo pažymėjimas",
        text21: "Patvirtinkite savo tapatybės informaciją",
        text22: "Šalis",
        text23: "Miestas",
        text24: "Įveskite savo miestą",
        text25: "Įveskite savo vardą",
        text26: "Jūsų ID numeris",
        text27: "Įveskite savo ID numerį",
        text28: "Asmens tapatybės kortelės priekinė nuotrauka",
        text29: "Spustelėkite, kad įkeltumėte dokumentus",
        text30: "įkelti iš naujo",
        text31: "įkelti",
        text32: "Laikant asmens tapatybės nuotrauką",
        text33: "Spustelėkite, kad įkeltumėte savo ID nuotrauką",
        text34: "Susiejote „Google Authenticator“.",
        text35: "Raktas",
        text36: "Įveskite „Google“ patvirtinimo kodą",
        text37: "siųsti",
        text38: "Negali būti tuščias",
        text39: "El. pašto formatas neteisingas",
        text40: "Du slaptažodžiai nesuderinami",
        text41: "Nukopijuota sėkmingai",
        text42: "Kopijuoti nepavyko",
        text43: "Avataro modifikacija",
        text44: "pakeisti slaptažodį",
        text45: "El. pašto įrišimas",
        text46: "Keisti el",
        text47: "Mobiliojo telefono įrišimas",
        text48: "Modifikuoti mobilųjį telefoną",
        text49: "Google patvirtinimas",
        text50: "Susieti Google Authenticator",
        text51: "Įveskite „Google“ patvirtinimo kodą",
        text52: "sutaupyti",
        text53: "Patvirtinkite pateikimą",
        text54: "Peržiūrėk",
        text55: "privalomas",
        text56: "Išjunkite „Google“ patvirtinimą",
        text57: "Kitas žingsnis",
        text58: "Baigti",
        text59: "„Google“ patvirtinimas yra privalomas",
        text60: "„Google“ patvirtinimas buvo atsietas",
        text61: "Pirminis sertifikatas pateiktas",
        text62: "Išplėstinis sertifikatas pateiktas",
        text63: "Vaizdas neįkeltas",
        text64: "Persiūsti",
        text65: "Įveskite slapyvardį",
        text66: "Slapyvardis sėkmingai išsaugotas",
        text67: "Dar nėra įkeltų vaizdų",
        text68: "Slaptažodžio nustatymas iš naujo baigtas",
        text69: "El. paštas sėkmingai pakeistas",
        text70: "Avataras sėkmingai išsaugotas",
        text71: "Įkelti paveikslėlį",
        text72: "savo pašto dėžutę",
        text73: "Įveskite savo naują el",
        text74: "Tavo vardas",
        text75: "Eikite į autentifikavimą",
        text76: "Patvirtinkite savo asmens tapatybės dokumento nuotrauką"
    },
    retrievePassword: {
        formTitle1: "Atstatyti slaptažodį",
        formTitle2: "Jūsų turto saugumo sumetimais operacijos draudžiamos per 24 valandas po slaptažodžio pakeitimo.",
        formTitle3: "Atkurti slaptažodį",
        formTitle4: "Patvirtinkite pakeitimus",
        formTitle5: "Įveskite seną slaptažodį",
        formTitle6: "Įveskite naują slaptažodį",
        formTitle7: "Mobiliojo telefono atkūrimas",
        formTitle8: "El. pašto paieška"
    },
    home: {
        title1: "Populiariausia kriptovaliutų prekybos platforma",
        title3: "kodėl ",
        title4: " Tai didelio našumo atvirojo kodo blokų grandinės platforma, sukurta palaikyti ir valdyti saugią, suderinamą ir nuspėjamą skaitmeninę infrastruktūrą.",
        field1: "Įsteigta birža",
        field2: "Skaitmeninio turto finansinės paslaugos",
        field3: "Dešimtys milijonų vartotojų",
        field4: "Įsteigti kelis investuotojų apsaugos fondus",
        field5: "Greita prekyba",
        field6: "„CME Gruop“ gali suderinti pavedimus su itin mažu delsimu, kad gautų geriausią prekybos patirtį.",
        title5: "rinkos tendencija",
        title6: "Žiūrėti daugiau",
        table1: "Valiuta",
        table2: "Naujausia kaina",
        table3: "24h pakilimai ir nuosmukiai",
        table4: "24h prekybos apimtis",
        table5: "24h operacijų apimtis",
        table6: "Citatos",
        title7: "apie ",
        title8: " Esame įsipareigoję vartotojams teikti pažangiausius prekybos įrankius, novatoriškas technologijas ir neprilygstamos kokybės klientų aptarnavimą.",
        title9: "Skaitmeninio turto sritis keičiasi su kiekviena diena. Tik būdami toliaregiai ir sparčiai tobulėdami galime neatsilikti nuo technologinių naujovių tempo.",
        title901: " Pažangiausių skaitmeninio turto prekybos paslaugų teikimas mūsų vartotojams ir pasauliniams likvidumo tiekėjams.",
        title10: "Esame tvirtai įsitikinę, kad kiekvienas vartotojas nusipelno geriausios prekybos patirties。",
        title11: "Saugumas, kuriuo galite pasitikėti",
        title12: "Mūsų sudėtingos saugumo priemonės ir SAFU fondai apsaugo jūsų skaitmeninį turtą nuo visų pavojų。 ",
        title13: "Geriausi sandorių tarifai",
        title14: "Lengvatiniai sandorių tarifai, konkurencingos VIP teisės ir mėgaukitės aukščiausios kokybės paslaugomis.",
        title15: "24*7 valandų klientų aptarnavimo palaikymas",
        title16: "24/7 bet kuriuo oru, visu etatu, mes kuo greičiau atsakysime į jūsų užklausas.",
        title17: "0 mokestis prekybai",
        title18: "Norėdami saugiai ir greitai prekiauti skaitmeninėmis valiutomis be nulinių tvarkymo mokesčių, naudokite kelis mokėjimo būdus.",
        title19: "Prekiaukite bet kada ir bet kur",
        title20: "Puikiai suderinamas su keliais terminalais, bet kuriuo metu tenkinantis įvairių scenarijų operacijų poreikius",
        title21: "Patikrinkite realiojo laiko rinkos sąlygas bet kuriuo metu",
        title22: "Lengvai pirkite ir parduokite BTC, ETH, XRP ir kitą skaitmeninį turtą",
        title23: "Gaukite išankstinius įspėjimus apie jums svarbių kriptovaliutų kainų pokyčius",
        title24: "Peržiūrėkite Bitcoin neatidėliotinų paskolų, ateities paskolų ir pasirinkimo sandorių kainas",
        title25: "Palyginkite kriptovaliutų kainas įvairiose biržose",
        title26: "Užsiregistruokite dabar",
        title27: "doleris",
        title28: "24 valandų prekybos apimtis",
        title29: "Integruotas likvidumo tiekėjas",
        title30: "Vartotojas",
        title31: "Daugiau",
        title32: "„Binance Loan“ pridėjo nauju hipotekos turtu CTSI ir KSM ir pradėjo taikyti palūkanų normos mažinimo nuolaidas BUSD ir USDT!",
        title33: "Mūsų pranašumas",
        title34: "saugus ir stabilus",
        title35: "Aukščiausia techninė komanda, visapusiška saugumo apsauga, nepriklausomi tyrimai ir didelės spartos transakcijų sintezės variklio plėtra, vis tiek gali stabiliai ir patikimai veikti atliekant didžiulius vienu metu vykstančius sandorius.",
        title36: "Profesionalus atitikimas",
        title37: "Profesionali operacijų komanda, turinti ilgametę patirtį blockchain ir finansų srityje, turi suderinamą skaitmeninio turto prekybos licenciją ir 100% rezervo garantiją.",
        title38: "Pirmiausia vartotojas",
        title39: "Susidūrimas su pasauline rinka, kelių kalbų palaikymas, darbas 24 valandas per parą, 7 dienas per savaitę, stiprus bendruomenės palaikymas ir profesionalus klientų aptarnavimas.",
        title40: "didelio našumo",
        title41: "300 000 operacijų per sekundę, o užsakymo atsako laikas trumpesnis nei 1 milisekundė.",
        title42: "apie mus",
        title43: "Prekiaukite bet kada ir bet kur",
        title44: "Puikiai suderinamas su keliais terminalais, bet kuriuo metu tenkinantis įvairių scenarijų operacijų poreikius",
        title45: "（Nuskaitykite kodą, kad atsisiųstumėte）",
        title46: "Skaitmeninės valiutos naujienos",
        title47: "mūsų verslo partneris",
        title48: "Pralaimėtojų sąrašas",
        title49: "24h apyvarta",
        title50: "24h padidėjimas ir sumažėjimas"
    },
    quotation: {
        marketTrading: "Citatos",
        turnover: "Apimtis",
        optional: "Neprivaloma",
        contractMarket: "sutarčių rinka",
        currencyPair: "valiutų pora",
        latestPrice: "Uždarymo kaina",
        upsAndDowns: "Citatos pakeitimas",
        highest: "Aukščiausias",
        lowest: "Žemiausia",
        transactionAmount: "Sandorio apimtis",
        operate: "veikti",
        buy: "prekyba",
        topTurnovers: "Sandorių sąrašas",
        topGainers: "Gainerių sąrašas",
        tradingPair: "prekybos pora",
        buyOrder: "Pirkti",
        sellOrder: "pardavimo užsakymas"
    },
    accountChange: {
        demo: "modeliavimas",
        realAccount: "faktinė sąskaita",
        demoAccount: "Demonstracinė sąskaita",
        accountRole: "Paskyros vaidmuo",
        pleaseSelect: "Prašome pasirinkti",
        AccountChangeType: "Paskyros keitimo tipas",
        AccountType: "Paskyros tipas",
        currencyType: "Valiutos tipas",
        allType: "Visų rūšių",
        allAccount: "Visos sąskaitos",
        allCoin: "Visos valiutos",
        coin: "Valiuta",
        amount: "Keisti sumą",
        balance: "Sąskaitos balansas",
        time: "laikas",
        title: "Paskyros keitimo įrašai",
        filtrar: "filtras",
        check: "Pereiti prie",
        showOnly: "Rodyti tik valiutos atsargas",
        holdAssets: "Valiutos likutis",
        accountList: "Sąskaitų sąrašas"
    },
    contractTransaction: {
        chart: "diagramą",
        basicEdition: "Bazinė versija",
        depthMap: "Gylio žemėlapis",
        second: "Antra",
        minute: "tašką",
        day: "dangus",
        week: "savaitę",
        month: "mėnulis",
        open: "atviras",
        trade: "prekyba",
        buyLong: "ilgai pirkti",
        buyShort: "trumpas pirkimas",
        cannotBuy: "Ši valiuta nepalaiko pristatymo sutarčių operacijų",
        cannotBuy1: "Ši valiuta nepalaiko nuolatinės prekybos",
        tradingAssets: "prekybos turtas",
        amountAvailable: "Turimas kiekis",
        timeStr: "laikas",
        transactionPeriod: "prekybos laikotarpis",
        quantity: "kiekis",
        enterQuantity: "Įveskite kiekį",
        buyIn: "Eik ilgai",
        latestTransaction: "naujausia operacija",
        time: "laikas",
        direction: "kryptis",
        price: "kaina",
        sell: "trumpas",
        positionOrder: "Pristatymo užsakymas",
        historicalOrders: "Istoriniai užsakymai",
        product: "produktas",
        realAccount: "(tikroji sąskaita)",
        demoAccount: "(Demonstracinė sąskaita)",
        openingTime: "užsakymo laikas",
        openingPrice: "Atidarymo kaina",
        curretPrice: "Dabartinė kaina",
        liquidationPrice: "Uždarymo kaina",
        profitOrLoss: "Pelnas ir nuostoliai",
        endTime: "Uždarymo laikas",
        areYouSureToBuy: "Ar tikrai norite pirkti?",
        areYouSureToLongBuy: "Ar tikrai norite eiti ilgai?",
        areYouSureToShortBuy: "Ar tikrai norite nusipirkti trumpą?",
        successfullyBought: "Pirk sėkmingai",
        minBuy: "Minimali įpirka",
        assets: "turto",
        withdraw: "pasitraukti",
        entrustedOrder: "Įsakymas",
        total: "viso",
        continueToPlaceOrder: "Tęskite užsakymą",
        orderConfirmation: "Užsakymo patvirtinimas",
        buyRu: "pirkti",
        sellChu: "parduoti",
        areYouSureToSell: "Ar tikrai norite parduoti?",
        operation: "veikti",
        buyCover: "dangtelio padėtis",
        commitSuccess: "Sandoris sėkmingas",
        onlyEnterIntegers: "Galima įvesti tik sveikuosius skaičius",
        trend: "Tendencija",
        lotteryTime: "Užsakymo galutinis terminas",
        countdown: "Atgalinis skaičiavimas",
        period: "Sutrikimas",
        cycle: "Laiko tarpas",
        unlimited: "Neribota",
        put: "PUT",
        call: "CALL",
        pending: "Komisijoje",
        unopened: "Dar nenupieštas",
        opened: "Ištrauktas prizas",
        settlementPrice: "Atsiskaitymo kaina",
        rateOfReturn: "grąžos norma",
        currentPositions: "Dabartinė padėtis",
        positionQuantity: "Pozicijos kiekis",
        guarantee: "marža",
        text1: "kilti",
        text2: "rudenį",
        text3: "Laukia pirkimo",
        text4: "Užsakymo kiekis",
        text5: "Sandorių skaičius",
        text6: "Atšaukti",
        text7: "pristatymo laikas",
        text8: "Atšaukimo priminimas",
        text9: "Ar tikrai norite atšaukti užsakymą?",
        text10: "Neteisėtas kiekis",
        text11: "Užsakymo priminimas",
        text12: "Ar tikrai perkate bullish?",
        text13: "Ar esate tikri, kad pirksite puodą?",
        text14: "Atšaukimas sėkmingas"
    },
    mining: {
        title1: "Pasaulyje pirmaujanti „blockchain“ skaitmeninio turto kasybos platforma",
        title2: "Atviras ir skaidrus · saugus ir stabilus",
        title3: "Pasirinkite valiutą",
        title4: "Kasybos metinis pajamingumas",
        title5: "dangus",
        title6: "Kasybos laikotarpis",
        title7: "Produkto Aprašymas",
        btn: "Mano dabar",
        btn2: "uždarymas",
        tabs1: "vyksta",
        tabs2: "Išpirkta",
        table1: "produkto pavadinimas",
        table2: "Kasybos laikotarpis",
        table3: "Kasybos laikas",
        table4: "Kasybos kiekis",
        table5: "Galiojimo pabaigos data",
        table6: "Pereina iki brandos",
        table7: "Užsakymo būsena",
        egularMining: "Kasyba reguliariai",
        inProgress: "vyksta",
        redeemed: "Išpirkta",
        redemption: "išpirkimas",
        regularMining: "Kasyba reguliariai",
        earlyRedemption: "ankstyvas išpirkimas",
        need: "reikia",
        handlingFee: "tvarkymo mokestis",
        redemptionConfirmationMessage: "Iš anksto patvirtinkite, ar norite išpirkti？",
        form1: "Kasybos metinis pajamingumas",
        form2: "Kasybos laikotarpis",
        form3: "Kasybos valiuta",
        form4: "Prenumeratos suma (minimali/maksimali)",
        form5: "Išankstinio išpirkimo mokestis: ",
        form6: "pirkimo kaina",
        form7: "Turimos lėšos",
        form8: "pirkimo kaina",
        form9: "Turimos lėšos",
        form10: "Įveskite pirkimo sumą",
        form11: "visi",
        form12: "Numatomos pajamos",
        form13: "Nepakanka lėšų",
        form14: "Įveskite pirkimo sumą",
        form15: "Mano užsakymas",
        form16: "pajamos",
        form17: "užsakymo detalės",
        form18: "Ankstyvo išpirkimo instrukcijos:",
        form19: "Prenumeratos suma (minimali)",
        form20: "Prenumeratos suma (maksimali)",
        form21: "Laikomas kiekis",
        form22: "Pirkimo laikas",
        form23: "išpirkimo laikas",
        form24: "baigta",
        form25: "Prenumerata sėkminga",
        form26: "Išpirkimas sėkmingas",
        form27: "Lengvas finansų valdymas su daugiau nei 25% grąža, pranokstančia rinką, o įsigiję galite gauti atlygį",
        form28: "Pakvieskite draugus gauti 50 USD atlygį, o sutarčių kuponai taip pat gali grąžinti 20% komisinių."
    },
    assets: {
        content1: "Sąskaitos turtas",
        content2: "Šios dienos uždarbis",
        content3: "dabartinė paskyra",
        content4: "Tikroji sąskaita yra jūsų tikrasis sąskaitos turtas, kurį galima naudoti operacijoms ir pinigų išėmimams.",
        content5: "Išsiimti monetas",
        content6: "Įnešti monetas",
        content7: "mainai",
        content8: "perkėlimas",
        content9: "Prašome pasirinkti",
        content10: "Demonstracinė sąskaita",
        content11: "faktinė sąskaita",
        content12: "įsigyti turto",
        content13: "Ar tikrai norite pereiti prie tikros paskyros?",
        content14: "Ar tikrai norite pereiti prie demonstracinės paskyros?",
        content15: "sulaukti sėkmės",
        table1: "Valiuta",
        table2: "kiekis",
        table3: "užšaldyti",
        table4: "Yra",
        dialog1: "Produkto Aprašymas",
        dialog2: "1、Šį turtą leidžiama naudoti tik demonstracinės sąskaitos režimu",
        dialog3: "2、Siekiant išvengti piktnaudžiavimo, per mėnesį leidžiama tik vieną išpirkimą.",
        dialog4: "3、Gaunant turtą bus pridėta pradinio gauto turto suma ir pozicijos būsena nepasikeis.",
        dialog5: "4、Jei turite kitų klausimų, susisiekite su klientų aptarnavimo tarnyba",
        dialog6: "uždarymas",
        dialog7: "Gaukite demonstracinį turtą dabar",
        dialog8: "perkelti į",
        dialog9: "pervesti",
        dialog10: "jungiklis",
        dialog11: "Vertinimas",
        dialog12: "Demonstracinis turtas",
        dialog13: "Mano sąskaita",
        dialog14: "Visas sąskaitos turtas",
        dialog15: "Turto apžvalga",
        dialog16: "Bendras turto vertinimas",
        dialog17: "Turto vertinimas",
        dialog18: "Šios dienos uždarbis",
        dialog19: "įšaldyti lėšas",
        dialog20: "Kiekvieną mėnesį galite gauti imituojamą turto kvotą",
        dialog21: "gauti",
        dialog22: "Jūs sėkmingai gavote",
        dialog23: '30 dienų sukauptos pajamos',
        dialog24: "Finansinis produktas",
        dialog25: "Mano finansų valdymas",
        dialog26: "Istorinis finansų valdymas",
        dialog27: "istorijos įrašas",
        dialog28: "Finansavimo įrašai"
    },
    validator: {
        dialog14: "tikrintuvas",
        dialog15: "Įrišimo tikrintuvas",
        dialog16: "patvirtinimo jungiklis",
        dialog17: "Patvirtinimo kodas",
        dialog18: "Tikrinimo QR kodas",
        dialog19: "patvirtinimo raktas",
        dialog20: "sutaupyti",
        dialog21: "Pasirinkite tikrintuvą",
        dialog22: "kopijuoti raktą",
        dialog23: "Sėkmingai išsaugota",
        dialog24: "įveskite patvirtinimo kodą",
        dialog25: "Draugiškas priminimas: prieš patvirtindami išsaugojimą atidarykite atitinkamą APP ir nuskaitykite žemiau esantį QR kodą arba pridėkite raktą rankiniu būdu!",
        dialog26: "Suaktyvinkite autentifikavimo priemonę, kad užtikrintumėte maksimalų paskyros saugumą。",
        dialog27: "Kiekvieną kartą prisijungdami arba išėmę lėšas turėsite įvesti unikalų patvirtinimo kodą, pasiekiamą mobiliuoju telefonu.",
        dialog28: "Nustatykite tikrintuvą",
        dialog29: "padėti",
        dialog30: "Jūs nesusiejote autentifikavimo kodo. Gaukite stipresnę apsaugą naudodami autentifikavimo priemonę.",
        dialog31: "Valdymo priemonė dar nenustatyta. Pirmiausia nustatykite jį",
        dialog32: "Eikite į nustatymus"
    },
    recharge: {
        title1: "Nežinote, kaip pirkti naudojant skaitmeninę valiutą?",
        title2: "Tik trys paprasti žingsniai!",
        title3: "Išskleidžiamajame meniu pasirinkite norimą įsigyti skaitmeninę valiutą ir įveskite pirkimo kiekį arba sumą.",
        title4: "Pasirinkite pageidaujamą mokėjimo būdą",
        title5: "Patvirtinus mokėjimą, įsigyta skaitmeninė valiuta bus automatiškai pervesta į jūsų sąskaitą.",
        title6: "Pasirinkite valiutą, kurią norite papildyti",
        title7: "Indėlių rekordas",
        table1: "Valiuta",
        table2: "kiekis",
        table3: "Grandinės pavadinimas",
        table4: "valstybė",
        table5: "priežastis",
        table6: "laikas",
        table7: "Žiūrėti kuponą",
        dialog1: "Toliau įveskite patvirtinimo kodą",
        dialog2: "mokėjimo kodas",
        dialog3: "kopija",
        dialog4: "adresu",
        dialog5: "Indėlio suma",
        dialog6: "Sandorio ekrano kopija",
        dialog7: "Svarbus pastebėjimas",
        dialog8: "Įveskite indėlio sumą",
        dialog9: "įkelti paveikslėlį",
        dialog10: "Įveskite turinį",
        dialog11: "Įkelkite įkrovimo ekrano kopijas",
        dialog12: "Neperžiūrėta",
        dialog13: "Atstumtas",
        dialog14: "Deponuotas",
        tip1: "Sėkmingai pateikta",
        tip2: "Nukopijuota sėkmingai",
        tip3: "Kopijuoti nepavyko",
        tip4: "Pasirinkite valiutą, kurią norite papildyti",
        tip5: "1.Aukščiau pateiktas indėlio adresas yra oficialus platformos mokėjimo adresas. Ieškokite oficialaus platformos depozito adreso.；",
        tip6: "2.Įsitikinkite, kad jūsų kompiuteris ir naršyklė yra saugūs, kad informacija nebūtų sugadinta ar nutekinta.；",
        tip7: "3.Kai įkraunate aukščiau nurodytą adresą, visas tinklo mazgas turi patvirtinti, kad paskyra būtų gauta.；",
        tip8: "4.Pasirinkite aukščiau nurodytą žetonų sistemą ir valiutą ir perveskite atitinkamą sumą už indėlį. Neperveskite jokio kito nesusijusio turto, nes jis nebus atgautas.",
        tip9: "Išsaugoti QR kodą",
        tip10: "prisipilti",
        tip11: "Svarbus pastebėjimas",
        tip12: "Išorinės nuorodos",
        tip13: "Įkraukite QR kodą",
        tip14: "Kitas žingsnis",
        tip15: "Įkrovimo rekordas",
        tip16: "Įkrovimo detalės",
        tip17: "Indėlio adresas",
        tip18: "Greitas mokėjimas",
        tip20: "Nepakankamas balansas",
        tip22: "Pateikta, laukiama patvirtinimo",
        tip23: "laukia apmokėjimo",
        tip24: "Suma",
        tip25: "Mokėjimas atliktas, laukiama bloko patvirtinimo",
        tip26: "Mokėjimas atmestas",
        tip27: "Mokėjimo nesėkmė",
        tip28: "Mokėjimas sėkmingas",
        bankChannel: "Banko kortelės kanalas",
        tip29: "Istoriniai ieškojimai",
        tip30: "Valiutų sąrašas",
        tip31: "Pasirinkite tinklą",
        tip32: "Kai įkraunate šią valiutą, įkraukite tik per toliau nurodytus palaikomus tinklus.",
        tip33: "Išėmę šią valiutą, išimkite tik per toliau nurodytus palaikomus tinklus.",
        tip34: "Greitas įkrovimas",
        tip35: "Nuskaitykite kodą, kad įkrautumėte",
        tip36: "Rankinis įkrovimas",
        tip37: "Įkrovimo tinklas",

        tip38: "Įkrovimo adresas",
        tip39: "Įkrovimo suma",
        tip40: "Operacijos kvito įkėlimas",
        tip41: "įkelti paveikslėlį",
        tip42: "patvirtinti pateikimą",
        tip43: "patvirtinti mokėjimą",
        tip44: "Pastaba: Patvirtinkite adresą, kurį norite papildyti. Mes neatsakome už pinigų praradimą, jei jį užpildysite neteisingai.",
        tip45: "priminti",
        tip46: "Adresas sėkmingai nukopijuotas!",
        tip47: "Nepavyko nukopijuoti adreso!",
        tip48: "Nepakankamas likutis",
        tip49: "Įkrovimas buvo sėkmingai pateiktas ir laukia patvirtinimo grandinėje.",
        tip50: "Nepavyko įkrauti",
        tip51: "Neteisinga papildymo suma",
        tip52: "Nepavyko prisijungti",
        tip53: "Piniginė neprisijungta",
        tip54: "Ryšio atsisakyta",
        tip55: "Pateikta sėkmingai, laukiama klientų aptarnavimo peržiūros ir patvirtinimo",
        tip56: "Įkelkite operacijos kvito ekrano kopiją",
        tip57: "Pateikimas nepavyko",
        tip58: "Įkrovimo rekordas",
        tip59: "Išėmimų įrašas",
        tip60: "Papildyti valiutą",
        tip61: "Išėmimo valiuta",
        tip62: "Įkrovimo adresas",
        tip63: "Ekrano kopija rodoma",
        tip64: "Spustelėkite norėdami padidinti vaizdą",
        tip65: "Įkrovimo laikas",
        tip66: "Atmetimo priežastis",
        tip67: "Išėmimo suma",
        tip68: "Gauta suma",
        tip69: "Grynųjų pinigų išėmimo tinklas",
        tip70: "Pašalinimo adresas",
        tip71: "Atsiėmimo laikas",
        tip72: "uždarymas",
        tip73: "Sandorio ekrano kopija",
        tip74: "Laukiama peržiūra",
        tip75: "Atstumtas",
        tip76: "baigtas",
        tip77: "Atstumtas",
        tip78: "Audituota",
        tip79: "Išmokėta",
        tip80: "ekstraktas",
        tip81: "perdavimo tinklas",
        tip82: "Adresas / sąskaita faktūra",
        tip83: "Atsiimti visus",
        tip84: "Neimkite pinigų tiesiogiai sutelktinio finansavimo ar ICO adresu, kitaip negalėsite gauti sutelktinio finansavimo ar ICO išduotų žetonų.",
        tip85: "Atvykimo kiekis",
        tip86: "Patvirtinkite atsiėmimą",
        tip87: "Neteisingas atsiėmimo adresas",
        tip88: "Neteisinga išėmimo suma",
        tip89: "Išsiimti suma yra mažiausiai",
        tip90: "Didžiausia išėmimo suma yra",
        tip91: "Buvo pateiktas prašymas dėl atsisakymo",
        tip92: "adresų sąrašas",
        tip93: "Jūs dar nepridėjote adreso",
        tip94: "Pridėkite jį dabar",
        tip95: "Pridėti adresą",
        tip96: "pridėti naują adresą",
        tip97: "Prašome pasirinkti",
        tip98: "adresu",
        tip99: "Pasirinkite perdavimo tinklą",
        tip100: "Įveskite adresą",
        tip101: "Adresas sėkmingai pridėtas",
        tip102: "sandoryje",
    },
    fundExchange: {
        title1: "Kaip pasikeisti lėšas?",
        title2: "Pasirinkite tinkamą valiutą, kurią norite konvertuoti。",
        title3: "Pasirinkite tinkamą valiutą konvertuoti。",
        title4: "Įveskite keičiamą sumą ir spustelėkite Pateikti, kad užbaigtumėte fondo keitimą.",
        title5: "iš",
        title6: "to",
        title7: "Keitimo kiekis",
        title8: "valiutos kursas",
        title9: "Yra",
        title10: "Įveskite išpirkimo kiekį",
        title11: "Nėra atitinkamos mainų prekybos poros.",
        title12: "Įveskite kiekį, kurį norite išpirkti",
        title13: "Išpirkimas sėkmingas",
        title14: "Mainų įrašas",
        table1: "Naudokite valiutą",
        table2: "kiekis",
        table3: "valiutos kursas",
        table4: "Keisti valiutą",
        table5: "Kvitas",
        table6: "laikas",
        title15: "iš",
        title16: "Šiuo metu nėra laisvų išteklių, pasirinkite kitą"
    },
    fundTransfer: {
        title1: "Kaip pervesti lėšas?",
        title2: "Pasirinkite dabartinę sąskaitą, kurią norite perkelti。",
        title3: "Pasirinkite paskyrą, kurią norite perkelti。",
        title4: "Įveskite pervedimo sumą ir spustelėkite Pateikti, kad užbaigtumėte pervedimą.",
        title5: "Valiuta",
        title6: "Perduoti kiekį",
        title7: "Įveskite pervestiną sumą",
        title8: "perdavimo įrašas",
        title9: "Pasirinkite piniginės tipą",
        title10: "Pasirinkite valiutą",
        title11: "Pasirinkite piniginės tipą",
        title12: "Pasirinkite valiutą",
        title13: "Įveskite pervestiną sumą",
        title14: "Sėkmingai pateikta",
        table1: "Pervesti sąskaitą",
        table2: "pervedimo valiuta",
        table3: "Perduoti kiekį",
        table4: "pervedimo sąskaita",
        table5: "laikas",
        table6: "perkėlimas",
        table7: "Lėšų pervedimas",
        table8: "Perkelti į",
        table9: "perdavimo įrašas",
        table10: "Perdavimo detalės",
        table11: "Perdavimas sėkmingas",
        table12: "Perdavimas nepavyko",
        table13: "Einamosios sąskaitos pervesti negalima"
    },
    withdrawal: {
        title1: "Svarbus pastebėjimas",
        title2: "1.Siekdami išvengti arbitražo, galite kreiptis dėl valiutos išėmimo, kai operacijos apimtis pasiekia ribą.",
        title3: "2.Atsiėmimo paraiška bus įskaityta per 24 valandas po pateikimo.",
        title4: "3.Pateikus paraišką dėl išėmimo, lėšos yra įšaldytos, nes vyksta išėmimas ir lėšos yra laikinai laikomos sistemoje.",
        title5: "Valiuta",
        title6: "piniginės adresą",
        title7: "Išimtų monetų kiekis",
        title8: "Monetų išėmimo įrašas",
        title9: "Pasirinkite valiutą",
        title10: "Pasirinkite grandinės tipą",
        title101: "",
        title11: "prašome įvesti",
        title12: "piniginės adresą",
        title13: "Sėkmingai pateikta",
        title14: "Peržiūrimas",
        title15: "Peržiūra sėkminga",
        title16: "Audito nesėkmė",
        title17: "Išmokėta",
        title18: "Įveskite arba įklijuokite savo piniginės adresą",
        title19: "Įveskite išėmimo sumą",
        title20: "tvarkymo mokestis",
        title21: "Tikrasis atvykimas",
        table1: "Valiuta",
        table2: "Išimtų monetų kiekis",
        table3: "Grandinės pavadinimas",
        table4: "piniginės adresą",
        table5: "valstybė",
        table6: "priežastis",
        table7: "taikymo laikas",
        table8: "Išsiimti monetas",
        table81: "Išsiimti monetas",
        table9: "Pašalinimo adresas",
        table10: "Pasirinkite valiutą, kurią norite atsiimti",
        table11: "Įsitikinkite, kad įvedėte",
        table12: 'Adresas (dažniausiai prasideda "0x")',
        table13: "Išimamos monetos (atskaitomas tvarkymo mokestis)：",
        table14: "Pasirinkite valiutą",
        table15: "Susidurti su problemomis? Greitas atsiliepimas",
        table16: "Balansas",
        table17: "Išsiskyrimo detalės",
        password: "Slaptažodis",
        passwordTips: "Įveskite slaptažodį",
        passwordAg: "Patvirtinti slaptažodį",
        passwordAgTips: "Dar kartą įveskite slaptažodį",
        oldPassword: "Senas slaptažodis",
        oldPasswordTips: "Įveskite seną slaptažodį",
        newPassword: "Naujas Slaptažodis",
        newPasswordTips: "Įveskite naują slaptažodį",
        passwordNotSame: "Slaptažodžiai nenuoseklūs",
        withdrawPasswordSet: "Nustatykite išėmimo slaptažodį",
        withdrawPasswordModify: "Pakeiskite išėmimo slaptažodį",
        withdrawPassword: "Atšaukti slaptažodį",
        withdrawPasswordTips: "Įveskite atsiėmimo slaptažodį",
        setWithdrawPasswordFirst: "Pirmiausia nustatykite atsiėmimo slaptažodį",
        withdrawPasswordSetSuccess: "Sąranka sėkminga",
        withdrawPasswordModifySuccess: "Sėkmingai pakeista",
        submit: "Pateikti",
    },
    customer: {
        content1: "internetinė paslauga",
        content2: "klientų aptarnavimas",
        content3: "Įveskite savo kontaktinę informaciją",
        content4: "Įveskite turinį",
        content5: "siųsti",
        content6: "Nepavyko išsiųsti, nepavyko prisijungti prie tinklo",
        content7: "paveikslėlį",
        content8: "žinutė tuščia",
        content9: "mano dalis",
        content10: "pasidalinti nuoroda",
        content11: "išsaugoti paveikslėlį",
        content12: "mano uždarbis",
        content13: "Lygio aprašymas",
        content14: "Komandos dydis",
        content15: "Kvietimo pajamos",
        content16: "Instrukcijų dalijimasis",
        content17: "narystės lygis",
        content18: "Įkrovimo suma yra didesnė nei",
        content19: "Komandos lygis",
        content20: "Komandos lygis ir pajamos",
        content21: "Kad atitiktų sąlygas",
        content22: "Paskirstymo pajamos",
        content23: "lygio komanda",
        content24: "lygis, pakvietimas",
        content25: "galiojantys nariai",
        content26: "pirminių pajamų",
        content27: "antrinių pajamų",
        content28: "3 lygio pajamos",
    },
    standardContract: {
        increaseMargin: "padidinti maržą",
        increaseAmount: "padidinti sumą",
        Pleaseenterthemargin: "Įveskite maržos sumą, kurią norite padidinti",
        Pleaseenterthecorrect: "Įveskite teisingą indėlio sumą",
        Increasemarginsuccessfully: "Sėkmingai padidinkite maržą",
        takeProfitPriceWrong: "Neteisingai įvertinkite pelno kainą",
        stoppriceerror: "Stop loss kainos klaida",
        thetakeprofit1: "Paėmimo pelno kaina turi būti didesnė už rinkos kainą",
        thetakeprofit2: "Stop loss kaina turi būti mažesnė už rinkos kainą",
        thetakeprofit3: "Paėmimo pelno kaina turi būti mažesnė už rinkos kainą",
        thetakeprofit4: "Stop loss kaina turi būti didesnė už rinkos kainą",
        thetakeprofit5: "Netinkamas kiekis",
        estimatedprofitloss: "Numatomas pelnas ir nuostolis",
        positionAmount: "Pareigų skaičius",
        closeAmount: "Uždarymo kiekis",
        whenthelatest: "Pasiekus naujausią kainą",
        whenthelatest2: ", bus suaktyvintas rinkos kainos take-profit orderis uždaryti esamą poziciją. Numatomas pelnas ir nuostolis",
        whenthelatest3: ", bus suaktyvintas rinkos sustabdymo nuostolių pavedimas, kad būtų uždaryta dabartinė pozicija. Numatomas pelnas ir nuostolis",
        contract: "sutartis",
        ordercanceledsuccessfully: "Užsakymas sėkmingai atšauktas",
        successfullyordered: "sėkmingai užsakyta",
        positionopeningreminder: "Pozicijos atidarymo priminimas",
        wrongquantity: "Netinkamas kiekis",
        quantitycannot: "Kiekis negali būti didesnis nei",
        modificationstoploss: "Sėkmingai modifikuokite pelną ir sustabdykite nuostolius",
        positionclosedsuccessfully: "Pozicija sėkmingai uždaryta",
        orderCancellation: "Užsakymo atšaukimas",
        orderCancellation2: "Ar tikrai norite atšaukti užsakymą?",
        tobeexecuted: "Kad būtų įvykdyta mirties bausmė",
        expired: "pasibaigęs",
        failed: "nepavyko",
        contractTransaction: "Neterminuota sutartis",
        increase: "Padidinti",
        openPosition: "Pilnas sandėlis",
        isolatedPosition: "Izoliuota padėtis",
        limitOrder: "kainos riba",
        marketOrder: "rinkos kaina",
        pleaseSelectLeverage: "Pasirinkite svertą",
        pleaseEnterQuantity: "Įveskite kiekį",
        canOpenMore: "Maksimali padėtis, kurią galima atidaryti",
        contractAmount: "Sutarties suma",
        openingFee: "tvarkymo mokestis",
        currentPosition: "Padėtis",
        historicalPositions: "Istoriniai sandoriai",
        currentCommission: "Dabartinis užsakymas",
        historicalCommission: "istorinė komisija",
        buyPrice: "pirkimo kaina",
        income: "pelno",
        quantity: "kiekis",
        marginRate: "maržos norma",
        initialMargin: "Pradinė paraštė",
        estimatedPriceParity: "Priverstinio likvidavimo kaina",
        operate: "veikti",
        finishQuantity: "Sandorio apimtis",
        averagePrice: "vidutinė sandorio kaina",
        pleaseEnterLeverage: "Įveskite svertą",
        takeProfitAndStopLoss: "Gaukite pelną ir sustabdykite nuostolius",
        takeProfit: "Pasiimk pelną",
        stopLoss: "sustabdyti nuostolius",
        openLong: "Long",
        openShort: "Short",
        liquidation: "Uždaryti padėtį",
        marketLquidation: "Rinkos kaina yra vienoda",
        cancel: "Atšaukti užsakymą",
        enterBuyPrice: "Įveskite pirkimo kainą",
        areYouSureLquidation: "Ar tikrai uždarysite poziciją?",
        confirm: "Žinoma",
        enterStopWinPrice: "Įveskite pelno kainą",
        enterStopLossPrice: "Įveskite nuostolio sustabdymo kainą",
        commissionTime: "Komisijos laikas",
        commissionPrice: "Komiso kaina",
        commissionQuantity: "Bendra komisinių suma",
        volumeAlreadyTraded: "Suma užpildyta",
        areYouSureToWinOrLoss: "Ar tikrai norite sustabdyti pelną ir sustabdyti nuostolius?",
        maxQuantity: "Maksimali padėtis",
        saleQuantity: "Pozicija uždaryta",
        salePrice: "vidutinė uždarymo kaina",
        saleTime: "laikas",
        succeeded: "pavyko",
        cancelled: "Atšauktas",
        piece: "atviras",
        triggerPrice: "startinė kaina",
        setWin: "Nustatykite pelną",
        setLoss: "Nustatykite stop loss",
        enterWinQuantity: "Įveskite pelno sumą",
        enterLossQuantity: "Įveskite sustabdymo nuostolių sumą",
        planCommission: "Plano komisija",
        enterWinTriggerPrice: "Įveskite pelno gavimo pradinę kainą",
        enterLossTriggerPrice: "Įveskite sustabdymo nuostolių pradinę kainą",
        insufficientQuantity: "Nepakankamas kiekis",
        enterTriggerPrice: "Įveskite pradinę kainą",
        tips1: "Jūsų užsakymo kaina yra didesnė už dabartinę kainą ir bus vykdoma tiesiogiai pagal dabartinę rinkos kainą. Ar tikrai norite pirkti?",
        tips2: "Jūsų užsakymo kaina yra mažesnė už dabartinę kainą ir bus vykdoma tiesiogiai pagal esamą rinkos kainą. Ar tikrai pirksite?",
        type: "tipo",
        increaseQuantity: "Padidinti padėtį",
        reduceQuantity: "Sumažinti pozicijas",
        limitCommission: "limitinis pavedimas",
        tips3: "Stop loss kaina turi būti mažesnė už rinkos kainą",
        tips4: "Paėmimo pelno kaina turi būti didesnė už rinkos kainą",
        tips5: "Stop loss kaina turi būti didesnė už rinkos kainą",
        tips6: "Paėmimo pelno kaina turi būti mažesnė už rinkos kainą",
        tips7: "Stop loss kaina turėtų būti mažesnė už rinkos kainą ir mažesnė už užsakymo kainą",
        tips8: "Pelno kaina turi būti didesnė už užsakymo kainą (gali būti mažesnė už rinkos kainą)",
        tips9: "Stop loss kaina turėtų būti didesnė už rinkos kainą ir didesnė už užsakymo kainą",
        tips10: "Pelno kaina turi būti mažesnė už užsakymo kainą (gali būti didesnė už rinkos kainą)",
        accountEquity: "Sąskaitos balansas",
        unrealizedPL: "nerealizuotas pelnas ar nuostolis",
        tips11: "Ar esate tikras, kad esate teisus",
        tips12: "Rinkos kaina",
        tips13: "Uždarykite visas pozicijas",
        tips14: "Daugiau nepriminti",
        profitRate: "Uždarymo grąžos norma",
        openTime: "Atidarymo laikas",
        unwindTime: "Uždarymo laikas",
        dealTime: "Sandorio laikas",
        amountClose: "Uždarytos padėties kiekis",
        long: "daug",
        short: 'nulinis',
        orderQuantity: "Užsakymo kiekis",
        entrustedMargin: "patikėta marža",
    },
    spotGoods: {
        spotGoods: "patikėta marža",
        sellPrice: "pardavimo kaina",
        orderRecord: "„Flash“ išpirkimo įrašas",
        transactionTime: "Sandorio laikas",
        maxBuy: "galima įsigyti",
        maxSell: "Galima parduoti",
        purchaseQuantity: "Pirkimo kiekis",
        slippage: "Paslydimas",
        convertTips: "Sandorį užbaigsime už geriausią kainą, nuokrypį nuo 0 iki 5%。",
        changePrice: "Dabartinė keitimo kaina",
        consume: "vartoti",
        get: "gauti",
        changeTips: "Ar tikrai norite išpirkti?",
        confirm: "Patvirtinti keitimą"
    },
    news: {
        title: "Naujienų centras",
        redMore: "Skaityti daugiau",
    },
    credit: {
        credit: "kredito Taškai",
        creditScore: "bendras kredito balas",
        latestEntry: "naujausias rekordas",
        liveUpdate: "Tiesioginis atnaujinimas",
        systemEvaluation: "Sistemos įvertinimas",
        time: "data",
        name: "vardas",
        reason: "priežastis",
        scoreStory: "Kredito balo rekordas"
    },
    borrowing: {
        borrowing: "paskola",
        diversifiedMarket: "Diversifikuotos rinkos",
        totalSupply: "Bendra pasiūla",
        totalBorrowings: "visų skolų",
        tips1: "Tai yra bendra suma, kurią galite pasiskolinti už užstatą, neviršijant skolinimosi limito.",
        tips2: "Jūsų stabili palūkanų norma išliks tokia pati visą paskolos laikotarpį. Rekomenduojamas ilgalaikiam tiekimui ir vartotojams, kurie mėgsta nuspėjamumą.",
        totalSupplys: "visos pasiūlos",
        supplyAPR: "pasiūlos norma",
        totalBorrowings: "Visas skolinimasis",
        borrowAPR: "skolinimosi norma",
        check: "Patikrinti",
        market: "turgus",
        availableLiquidity: "Turimas likvidumas",
        currencyPrice: "dabartinės valiutos kaina",
        supplyAssets: "tiekti turtą",
        tips3: "Pastaba: toliau nurodyta palūkanų norma yra fiksuota palūkanų norma Pasibaigus tiekimo laikotarpiui, pagrindinė suma ir pajamos bus grąžintos į jūsų sąskaitą.",
        supplyCycle: "tiekimo ciklas",
        minimumSupply: "minimali pasiūla",
        supply: "tiekimas",
        borrowedAssets: "skolinto turto",
        tips4: "Ką reikia žinoti: norėdami pasiskolinti pinigų, turėsite pateikti bet kokį užstatą ar įrodymus，",
        tips5: "Žiūrėkite hipotekos turto aprašymą。",
        repaymentCycle: "grąžinimo ciklas",
        BorrowableAmount: "Turima paskolos suma",
        borrow: "paskola",
        accountInformation: "Paskyros informacija",
        walletBalance: "piniginės likutis",
        canSupply: "Yra",
        AmountCanBeBorrowed: "Visa galima paskolos suma",
        borrowedAmount: "Pasiskolinta suma",
        remainingAmount: "esamas likutis",
        getBorrowednAmount: "Gaukite paskolos limitą",
        supplyOrder: "tiekimo tvarka",
        borrowedOrder: "paskolos orderis",
        supplyAmount: "tiekimo kiekis",
        expectedProfits: "Numatoma grąža",
        supplyTime: "Tiekimo laikas",
        expirationTime: "Galiojimo pabaigos data",
        borrowingAmount: "Paskolos suma",
        dueRepayment: "Grąžinimo suma",
        borrowingTime: "Išleidimo laikas",
        repaymentTime: "Grąžinimo laikas",
        repay: "grąžinimas",
        supplyCurrency: "tiekimo valiuta",
        buyNow: "Pirkti dabar",
        supplyRecords: "tiekimo įrašus",
        borrowRecords: "Paskolos įrašai",
        completed: "baigtas",
        borrowNow: "Pasiskolinkite dabar",
        borrowCurrency: "Skolinimosi valiuta",
        borrowMin: "mažiausias",
        borrowMax: "maksimalus",
        borrowRange: "Paskolos suma (minimali/maksimali)",
        tips6: "Grąžinkite laiku, jei vėluojate, bus priskaičiuota papildoma dienos suma (pagrindinė suma + palūkanos).",
        tips7: "už delspinigius。",
        pleaseEnterBorrowAmount: "Įveskite paskolos sumą",
        interest: "Palūkanos",
        tips8: "Ar tikrai norite grąžinti iš anksto?",
        borrowChannel: "Skolinimosi kanalas",
        tips9: "Pradėkime nuo pažinties su jumis",
        name: "vardas",
        lastName: "pavardė",
        birthDate: "Gimimo data",
        tips10: "Šiek tiek daugiau informacijos, koks jūsų adresas?",
        familyAddress: "Namų adresas (įskaitant įrenginio numerį)",
        city: "Miestas",
        country: "tauta",
        postalCode: "Pašto kodas",
        pleaseEnterYourHomeAddress: "Įveskite savo namų adresą",
        tips11: "Papasakokite apie savo finansinę padėtį",
        tips12: "Vėliau mums gali tekti patvirtinti šią informaciją, todėl stenkitės būti kuo tikslesni",
        yourMonthlyIncome: "savo mėnesines pajamas",
        enterYourMonthlyIncome: "Įveskite savo mėnesines pajamas",
        extraIncomeOptional: "Papildomos pajamos (neprivaloma）",
        enterExtraIncome: "Įveskite papildomas pajamas",
        monthlyRentOrMortgagePayment: "Mėnesio nuomos arba būsto paskolos įmoka",
        enterMonthlyRent: "Įveskite mėnesinį nuomos arba hipotekos mokėjimą",
        tip13: "Pasakykite mums, jei turite hipoteką",
        tip14: "Jei hipotekos garantija nepasirenkama, tikimybė, kad bus atlikta peržiūra, yra maža.",
        isThereMortgage: "Ar yra hipoteka?",
        selectIsThereMortgage: "Prašome pasirinkti, ar yra hipoteka",
        selectMortgageType: "Pasirinkite hipotekos tipą",
        yes: "taip",
        no: "ne",
        uploadScreenshotOfTransaction: "Įkelkite operacijų ekrano kopijas",
        tip15: "Susisiekime",
        tip16: "Galime susisiekti su jumis šiuo numeriu, jei mums reikės daugiau informacijos apie jūsų paskolos paraišką",
        tip17: "Aš perskaičiau ir elektroniniu būdu pasirašiau savo sutikimą",
        tip18: "Naudojimo sąlygos ir elektroninis sutikimas",
        tip19: "，Tai apima jūsų sutikimą, kad galėtume siųsti jums informaciją apie mūsų",
        tip20: "Produkto ir paslaugų naudojimo sąlygos",
        tip21: "Užpildę informaciją, laukite sistemos įvertinimo ir peržiūros。",
        phoneNumber: "telefono numeris",
        enterPhoneNumber: "Įveskite savo telefono numerį",
        tip22: "Pažymėkite langelį, kad sutiktumėte su naudojimo sąlygomis ir elektronine sutikimo forma",
        inReview: "Peržiūrimas",
        applicationAmount: "Paraiškos suma",
        reasonForRejection: "Atmetimo priežastis",
        reapply: "Pakartotinai kreiptis",
        applyStatus: "paraiškos būsena",
        currentOrder: "dabartinė tvarka",
        interestRate: "palūkanų norma"
    },
    yuebao: {
        filed1: "investuoti",
        filed2: "išimti",
        filed3: "Dienos pajamos",
        filed4: "komandos pagreitis",
        filed5: "Deponuotas",
        filed6: "Vakar dienos uždarbis",
        filed7: "Bendros pajamos",
        filed8: "Turimos lėšos",
        filed9: "Įveskite sumą",
        filed10: "Likvidumo kasyba",
        filed11: "Įvadas",
        field12: "Minimali pirkimo kaina",
        field13: "Daugiausiai galite nusipirkti",
        filed14: "Prenumerata",
        filed15: 'reguliarus',
        filed16: 'metinė palūkanų norma',
    },
    tipsPopover: {
        title: "Įdiekite šią programą",
        press: "pagal",
        and: "ir",
        scrren: "Pridėti prie pagrindinio ekrano",
        hasInstall: "(Jei jau įdiegta, uždarykite langą)",
    },
    follow: {
        title1: "Tolesnio plano",
        follow_text1: "Sukurti tvarką",
        follow_text2: "Išleidimo istorija",
        follow_text3: "titulą",
        follow_text4: 'prekybos pora',
        follow_text5: 'Pirkimo trukmė',
        follow_text6: 'užsakymo laikas',
        follow_text7: 'išleidimo laikas',
        follow_text8: 'Sekėjų skaičius',
        follow_text9: 'Užsakymo suma',
        follow_text10: 'veikti',
        follow_text11: 'pakviesti',
        follow_text12: 'Vykdykite užsakymo nurodymus',
        follow_text13: 'Nustatykite užsakymo sąlygas',
        follow_text14: 'Sąlygos sekti užsakymus',
        follow_text15: 'nustatyta suma',
        follow_text16: 'procentais',
        follow_text17: 'Pakviesti žmonės',
        follow_text18: 'Kitos šalies ID',
        follow_text19: "Patvirtinkite, kad laikotės nurodymo",
        follow_text20: "Jūsų užsakymo suma (neprivaloma)",
        follow_text21: "Įveskite pavadinimą",
        follow_text22: "Pasirinkite prekybos porą",
        follow_text23: "Prašome pasirinkti užsakymo kryptį",
        follow_text24: "Pasirinkite pirkimo trukmę",
        follow_text25: "Prašome pasirinkti užsakymo laiką",
        follow_text26: "Prašome pasirinkti pirkimo kiekį",
        follow_text27: "Maksimalus pirkimo kiekis negali būti mažesnis už minimalų pirkimo kiekį",
        follow_text28: "Minimali įpirka",
        follow_text29: "Dauguma perka",
        follow_text30: "Sėkmingai sukurti kopijavimo užsakymą",
        follow_text31: "Prekybos porų sąrašas",
        follow_text32: "Jau vykdė įsakymą",
        follow_text33: "Įveskite pakviestojo informaciją",
        follow_text34: "Pakviestas",
        follow_text35: "pakvietė mane",
        follow_text36: "Istorijos kopijavimas",
        follow_text37: "Užsakymo sumos diapazonas",
        follow_text38:"Įveskite užsakymo kodą"
    },
    followHistory: {
        title1: 'Išleidimo istorija',
        title2: "Istorijos kopijavimas",
        follow_h_text1: "Bendra užsakymo suma",
        follow_h_text2: "Bendras užsakymus vykdančių žmonių skaičius",
        follow_h_text3: "Išleidimų skaičius",
        follow_h_text4: "laimėjimo norma",
        follow_h_text5: "Įsakymų vykdymo kartų skaičius",
        follow_h_text6: "Gaukite pelno iš šių užsakymų",
        follow_h_text7: "kryptis",
        follow_h_text8: "laimėti",
        follow_h_text9: "trūkumas",
    },
    "download.description.C80C1Edd6Bee12Bc": "1.Leisti atsisiųsti aprašo failus",
    "download.description.2F5Bc180F92642B4": "2.Aprašymo failas atsisiųstas",
    "download.description.3C3B849F6Ccf712F": "3.Telefone įveskite [Nustatymai] ir atsisiųstas aprašo failas bus rodomas po paskyros informacija.",
    "download.description.86Affd862985E045": "4.Spustelėkite norėdami atsisiųsti aprašo failą",
    "download.description.32832492Bfc1D95E": "5.Spustelėkite norėdami įdiegti",
    "home.index.04Ee893775563F25": "Laukiu loterijos burtų",
    "home.index.04Ee893775563F26": "Vyksta loterija",
    "passwod.limit":"Slaptažodžio ilgis turi būti didesnis arba lygus 6 simboliams",
    "finance.header.E5Dd9Bbdab4F52D2": "Aiuto per te",
    "finance.header.5Cbf11665B91D51D": "Balanso papildymas",
    "finance.index2.B1A4Be8079A937F8": "Intervallo di acquisto disponibile",
    "finance.index2.8371E53029Dc7558": "Commissione di penale",
    "finance.index2.Bf9A2C9Bf7Ecaf04": "Paskolos santykis",
    "finance.index2.2Ad78Bbd879C4990": "Acquista subito",
    "finance.index2.A3B7445Ea9D7E111": "Non disponibile per l'acquisto",
    "finance.index2.A3B7445Ea9D7E112": "Disponibile per l'acquisto",
    "finance.index2.87701Fe9Ad8540Dc": "Totale disponibile per l'acquisto / Già acquistato",
    "finance.index2.652Effdf5D1Af6A2": "Tasso di rendimento previsto",
    "finance.index2.D3C3C19De952Fc0C": "Data di acquisto",
    "finance.index2.6C4C46Cc4Da0C281": "Importo attuale",
    "finance.index2.3E9A6703Abd8A3E4": "Guadagno di ieri",
    "finance.index2.596704E9869C8134": "Guadagno totale",
    "finance.index2.0A845B549624B74B": "Tasso di rendimento annuo",
    "finance.index2.9A7758Cad0402366": "Attualmente detenuto",
    "finance.index2.9A7758Cad0402367": "Registro dei guadagni",
    "finance.index2.8B8Ceb7610C747Eb": "Cronologia",
    "finance.index2.8B8Ceb7610C747Ec": "Registro di investimento",
    "finance.index2.0B049108D57B9Dd5": "Prelievo anticipato",
    "finance.index2.37Ffde1Ee1D3C8D4": "Già prelevato anticipatamente",
    "finance.index2.12F6B830Aee90Efb": "Scaduto",
    "finance.index2.40E1944D8Cafbdad": "Importo detenuto",
    "finance.index2.9815C4F248B624F5": "Data di acquisto",
    "finance.index2.46F7Be1133B3E2C6": "Data di scadenza",
    "finance.index2.Fc8643Aa7Babcce8": "Guadagno",
    "finance.index2.1F2B02E97721B997": "Prelievo anticipato",
    "finance.index2.14E543A74595Efe8": "In attesa di approvazione",
    "finance.index2.14E543A74595Efe9": "In corso",
    "finance.index2.14E543A74595Efe0": "Concluso",
    "finance.index2.8E29Fbba37286B63": "Nome del tutor",
    "finance.index2.D736C17Df71Bcdb2": "Importo richiesto",
    "finance.index2.F38884Ed4410D9F6": "Importo approvato",
    "finance.index2.E3347Eb6F76Eda1C": "Guadagnato",
    "finance.index2.0Fc0070Cb4E9F5A8": "Data di investimento",
    "finance.index2.8Efd11Be6D9F43Df": "Inizio del periodo di guadagno",
    "finance.index2.16658A855F07D171": "Importo",
    "finance.index2.184333C81Babf2F1": "Tipo",
    "finance.index2.15Cba911299D4Afd": "Acquista subito",
    "finance.index2.Da1Cdb155Ae381Cd": "Importo prelevato",
    "finance.index2.15Efec8F145F2608": "Importo attuale (USDT) : ",
    "finance.index2.159253C05C270D46": "Importo detenuto (USDT) : ",
    "finance.index2.Caab3A4Ba941E0E3": "Commissione per il prelievo anticipato (USDT) : ",
    "finance.index2.Fb5Fc50Cf3716723": "Acquisto disponibile",
    "finance.index2.5Dcb4Ee5C7F1F4E1": "Inserisci importo",
    "finance.index2.5886C88906Cc4491": "Team di tutor di stelle, che gestisce ogni tuo investimento con cura",
    "finance.index2.5886C88906Cc4492": "Garanzia di capitale e interesse, flessibile e profitto in un mercato volatile",
    "finance.index2.F5Af24Dbad5837Ea": "Rimborso avvenuto",
    "finance.index2.Be15Df7F1D76F9B2": "Importo investito",
    "finance.index2.Fc57951B528F3Dd3": "Prestito disponibile",
    "finance.index2.3F91F76109Fdbdeb": "Prestito effettuato",
    "finance.index2.F68600F93Fe31213": "Prestito",
    "finance.index2.494E47D4025Da8E6": "Rimborsare",
    "finance.index2.27F6657Ebf2025E3": "Importo prestitato",
    "finance.index2.27F6657Ebf2025E4": "Importo rimborsato",
    "finance.index2.631Fc4Ce8Aeee66F": "Conferma prestito",
    "finance.index2.631Fc4Ce8Aeee66G": "Conferma rimborso",
    "time.text1":"Pradžios data",
    "finance.index2.631Fc4Ce8Aeee66H": "Turi būti patvirtinta",
}
